var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApache(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DCDDDE;stroke:#D9D9D9;stroke-width:0.2737;stroke-miterlimit:1.8369;}\r\n\t.st1{fill:#DCDDDE;stroke:#D9D9D9;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st2{fill:#231F20;stroke:#231F20;stroke-width:0.2737;stroke-miterlimit:1.8369;}\r\n\t.st3{fill:url(#SVGID_1_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st4{fill:url(#SVGID_2_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st5{fill:url(#SVGID_3_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st6{fill:url(#SVGID_4_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st7{fill:url(#SVGID_5_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st8{fill:url(#SVGID_6_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st9{fill:url(#SVGID_7_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st10{fill:url(#SVGID_8_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st11{fill:url(#SVGID_9_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st12{fill:url(#SVGID_10_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st13{fill:url(#SVGID_11_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st14{fill:url(#SVGID_12_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st15{fill:url(#SVGID_13_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st16{fill:url(#SVGID_14_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st17{fill:url(#SVGID_15_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st18{fill:url(#SVGID_16_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st19{fill:url(#SVGID_17_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st20{fill:url(#SVGID_18_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st21{fill:url(#SVGID_19_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st22{fill:url(#SVGID_20_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st23{fill:url(#SVGID_21_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st24{fill:url(#SVGID_22_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st25{fill:url(#SVGID_23_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st26{fill:url(#SVGID_24_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st27{fill:url(#SVGID_25_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st28{fill:url(#SVGID_26_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st29{fill:url(#SVGID_27_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st30{fill:url(#SVGID_28_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st31{fill:url(#SVGID_29_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st32{fill:url(#SVGID_30_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st33{fill:url(#SVGID_31_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st34{fill:url(#SVGID_32_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st35{fill:url(#SVGID_33_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st36{fill:url(#SVGID_34_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st37{fill:url(#SVGID_35_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st38{fill:url(#SVGID_36_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st39{fill:url(#SVGID_37_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st40{fill:url(#SVGID_38_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st41{fill:url(#SVGID_39_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st42{fill:url(#SVGID_40_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st43{fill:url(#SVGID_41_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st44{fill:url(#SVGID_42_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st45{fill:url(#SVGID_43_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st46{fill:url(#SVGID_44_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st47{fill:url(#SVGID_45_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st48{fill:url(#SVGID_46_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st49{fill:url(#SVGID_47_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st50{fill:url(#SVGID_48_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st51{fill:url(#SVGID_49_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st52{fill:url(#SVGID_50_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st53{fill:url(#SVGID_51_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st54{fill:url(#SVGID_52_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st55{fill:url(#SVGID_53_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st56{fill:url(#SVGID_54_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st57{fill:url(#SVGID_55_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st58{fill:url(#SVGID_56_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st59{fill:url(#SVGID_57_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st60{fill:url(#SVGID_58_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st61{fill:url(#SVGID_59_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st62{fill:url(#SVGID_60_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st63{fill:url(#SVGID_61_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st64{fill:url(#SVGID_62_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st65{fill:url(#SVGID_63_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st66{fill:url(#SVGID_64_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st67{fill:url(#SVGID_65_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st68{fill:url(#SVGID_66_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st69{fill:url(#SVGID_67_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st70{fill:url(#SVGID_68_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st71{fill:url(#SVGID_69_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st72{fill:url(#SVGID_70_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st73{fill:url(#SVGID_71_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st74{fill:url(#SVGID_72_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st75{fill:url(#SVGID_73_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st76{fill:url(#SVGID_74_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st77{fill:url(#SVGID_75_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st78{fill:url(#SVGID_76_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st79{fill:url(#SVGID_77_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st80{fill:url(#SVGID_78_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n\t.st81{fill:url(#SVGID_79_);stroke:#231F20;stroke-width:0.1166;stroke-miterlimit:1.8369;}\r\n")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.459215 0 0 .459215 22.715457 5.879981)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.8,109.6c-17.6-2.4-82.5-5.7-111.5-10.4c-23.3-3.8-46.1-10.7-67.8-18c-5.6-1.9-15.6-5.8-21.9-9.2 c-4-3.1-13.7-7.6-16.4-12c42.1,20,59,25.5,108.4,35.5C111.7,99.6,184.6,105.5,200.8,109.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.8,103.1l-1-0.6l-0.9-0.3l1.5,0.1l0.9,0.1l0.9,0.1l0.9,0.1l0.9,0.1l0.9,0l0.8,0.1l1.2,1.1l1.2,1.1l1,1.1 l0.9,1.1l0.9,1l1.7,2l0.9,0.9l0.9,0.9l0.9,0.8l1,0.8l1.1,0.8l1.2,0.7l1.3,0.7l1.5,0.6l1.7,0.5l-1.9,0.6l-1.8,0.2l-1.8-0.3 l-1.8-0.7l-1.8-1l-1.8-1.3l-1.7-1.5l-1.7-1.6l-1.6-1.6l-1.5-1.6l-1.4-1.6l-1.3-1.5l-1.2-1.2L115.8,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.2,105.3L122,104l-1.3-1.1l0.5,0h0.5l0.5,0.1l0.5,0l0.6,0l0.5,0.1l0.5,0l0.5,0.1l0.5,0l0.6,0l0.5,0.1 l1.2,0.1l0.6,0h0.6l0.6,0.1l0.4,0.7l0.5,0.8l0.7,1l0.7,1l0.9,1.1l0.9,1.1l1,1.2l1,1.1l1.1,1.1l1.1,1l1.1,0.9l1.1,0.8l1.1,0.6 l1.1,0.4l1,0.3h1l-2.2,0.4l-2,0l-1.9-0.2l-1.8-0.4l-1.6-0.7l-1.5-0.8l-1.5-1l-1.3-1.1l-1.3-1.2l-1.2-1.3l-2.4-2.7l-1.2-1.3 L123.2,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.3,107.6l-1.3-1.8l-1.4-2.1l0.8,0l0.8,0.1l1.6,0.2l0.8,0.1l0.8,0.1h1.8l0.8,0.8l0.7,0.8l0.7,0.8l0.7,0.9 l0.7,0.8l0.7,0.9l0.7,0.8l0.7,0.9l1.5,1.7l0.8,0.8l0.7,0.8l2.5,2.2l0.9,0.6l-1.2,0.2l-1.2,0.1l-1.1,0l-1.1-0.2l-1.1-0.3l-1.1-0.4 l-1.1-0.5l-1.1-0.7l-1.1-0.8l-1.1-1l-1.1-1.2l-1.2-1.3l-1.2-1.5L132.3,107.6z M138.1,105.9l-0.9-0.9l-0.8-0.8l5.3,0.5l0.6,0.8 l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.7,0.7l0.7,0.8l0.7,0.7l0.8,0.7l0.8,0.7l0.8,0.7l0.9,0.7l0.9,0.7 l-0.9,0.5l-1,0.2l-1-0.2l-1.1-0.4l-1.1-0.6l-1.1-0.9l-1.1-1l-1.1-1.2l-1.1-1.2l-1.1-1.3l-1-1.3l-1-1.2l-1-1.2L138.1,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.1,107.6l-1-1.5l-1-1.4l0.9,0.1l0.7,0l0.5,0l0.4,0.1l0.4,0.1h0.4l0.6,0l0.8,0l0.9,1.3l0.9,1.2l0.9,1.2 l1,1l1,0.9l1,0.9l1,0.8l1,0.7l1,0.6l1,0.5l0.9,0.4l0.9,0.4l0.9,0.3l0.8,0.2l0.8,0.1l0.7,0l-1.6,1l-1.4,0.6l-1.4,0.3H156l-1.3-0.3 l-1.3-0.4l-1.2-0.7l-1.2-0.9l-1.2-1.1l-1.2-1.1l-1.1-1.3l-1.1-1.3l-1.1-1.4L144.1,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.9,107.6l-0.9-1.2l-0.9-1.3l1,0.1l1.1,0.1l1,0.1l1,0.1l0.9,0.1l0.7,0l0.5,0.1l0.2,0l0.1,0.1l0.3,0.3 l0.4,0.4l0.5,0.5l0.5,0.6l0.7,0.7l0.7,0.7l0.8,0.8l0.9,0.8l1,0.8l1,0.8l1.1,0.8l1.1,0.7l1.1,0.7l1.2,0.6l1.2,0.5l-1.6,0.2 l-1.5,0.1l-1.5-0.1l-1.4-0.2l-1.3-0.3l-1.3-0.4l-1.2-0.5l-1.2-0.7l-1.2-0.7l-1.1-0.8l-1.1-0.9l-1-1l-1-1.1L148.9,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.3,107.6l-0.9-1l-0.8-1h0.6l0.7,0.1l0.8,0h0.8l0.8,0.1l0.8,0.1l0.6,0.1l0.5,0.1v0.1l0.2,0.3l0.5,0.4 l0.7,0.5l0.8,0.7l1,0.8l1.1,0.8l1.1,0.8l1.2,0.9l1.2,0.9l1.1,0.8l1.1,0.7l1,0.7l0.9,0.5l0.7,0.4l0.5,0.2l-1.3,0.3l-1.3,0.1 l-1.3-0.1l-1.3-0.2l-1.3-0.4l-1.3-0.5l-1.3-0.6l-1.3-0.8l-1.2-0.8l-1.2-0.9l-1.1-0.9l-1.1-1l-1-1L155.3,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160,106.8l-0.5-0.5l-0.2-0.2l0.6,0.1l1.4,0.1l0.7,0.1l0.8,0.1l1.6,0.1l0.8,0l0.9,0.5l0.9,0.5l1.7,1.1 l0.9,0.6l0.8,0.6l0.9,0.6l0.8,0.6l1.8,1.2l0.9,0.6l0.8,0.6l1.8,1.1l0.8,0.5l0.9,0.5l-0.8,0.8l-1,0.3l-1.3,0l-1.4-0.3l-1.6-0.6 l-1.6-0.8l-1.7-1l-1.7-1.1l-1.7-1.2l-1.6-1.2l-1.5-1.1l-1.3-1.1l-1.1-0.9L160,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.2,109l-1.8-1.2l-2-1.2l0.8,0.1l0.9,0.1h0.8l0.8,0l0.7,0l0.6,0.1l0.4,0.1l0.2,0l0.1,0.1l0.3,0.3l0.4,0.4 l0.6,0.5l0.7,0.6l0.8,0.8l0.9,0.7l1,0.8l1,0.8l1.1,0.8l1.1,0.7l1.1,0.7l1.1,0.6l1.1,0.5l1,0.3l0.9,0.2l-0.8,0.3l-0.8,0.2l-0.8,0 l-0.8-0.1l-0.8-0.3l-0.9-0.3l-0.9-0.5l-1-0.6l-1.1-0.7L175,113l-1.2-0.9l-1.4-0.9l-1.5-1L169.2,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.5,107.7l-0.5-0.4l-0.3-0.3l0.8,0.1l0.7,0.1l0.7,0l0.7,0.1l0.7,0.1l0.7,0l0.8,0.1l0.8,0.1l0.6,0.5 l0.6,0.5l0.6,0.5l0.6,0.6l0.6,0.6l0.6,0.6l0.7,0.6l0.7,0.6l1.4,1.1l0.7,0.5l0.7,0.4l0.8,0.4l0.7,0.3l0.8,0.3l0.8,0.2l-1.1,0.4 l-1.2,0.2l-1.3-0.1l-1.3-0.3l-1.4-0.5l-1.3-0.6l-1.4-0.8l-1.3-0.9l-1.2-0.9l-1.2-0.9l-1.1-0.9L173,109l-0.8-0.7L171.5,107.7z  M178.6,108.9l-0.9-0.8l-0.9-0.8l0.5,0.1l0.6,0.1l1.3,0.1l0.7,0.1l0.8,0.1l0.8,0.1l0.8,0l0.2,0.6l0.3,0.6l0.4,0.5l0.4,0.5 l0.5,0.5l1.1,1l0.6,0.4l0.6,0.4l0.7,0.3l0.7,0.3l0.7,0.2l0.8,0.2l0.8,0.2l0.8,0.1l0.8,0.1l-1,0.7l-1,0.4l-1,0.2l-1,0.1l-1-0.2 l-1-0.3l-1-0.4l-1-0.6l-0.9-0.6l-1-0.8l-0.9-0.8l-1.9-1.7L178.6,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.4,109.5l-0.4-0.8l-0.3-0.8l0.6,0.1l0.6,0l0.6,0.1l0.6,0.1l0.6,0l1.4,0.1l0.8,0l0.3,0.5l0.4,0.5l0.4,0.4 l0.4,0.4l0.4,0.4l0.5,0.3l0.4,0.4l0.5,0.3l0.5,0.3l0.5,0.2l0.5,0.3l0.6,0.2l0.6,0.2l0.6,0.2l0.7,0.1l0.7,0.2l-0.8,0.3l-0.9,0.3 l-0.9,0.1l-1,0l-1-0.1l-1.1-0.2l-2.1-0.6l-1-0.4l-0.9-0.5l-0.8-0.5l-0.8-0.6l-0.7-0.7L183.4,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,109.5l-0.4-0.6l-0.4-0.6l0.8,0.1l0.5,0l0.4,0l0.4,0.1l0.4,0h0.7v0.2l0.4,0.4l0.7,0.5l1,0.6l1.2,0.6 l1.2,0.6l1.2,0.5l1,0.3l-0.3,0.3l-0.5,0.2l-0.5,0.1h-0.6l-0.7,0l-0.7-0.1l-0.8-0.3l-0.8-0.3l-0.8-0.4l-0.8-0.4l-0.8-0.4l-0.7-0.5 l-0.7-0.5L188.9,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.6,108.9l-0.3-0.2l0-0.1l3.9,0.4l0.3,0.2l0.5,0.2l0.6,0.3l0.6,0.3l0.7,0.4l0.6,0.3l0.6,0.3l0.5,0.1 l-0.1,0.7l-0.2,0.4l-0.4,0.2l-0.5,0.1l-0.6-0.1l-0.7-0.3l-0.7-0.3l-0.8-0.4l-0.8-0.4l-1.5-1l-0.6-0.4l-0.5-0.4L191.6,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.7,110.3l-0.9-0.5l-0.8-0.4l-0.7-0.3l0.8,0.1l0.7,0.1l0.7,0l0.6,0l0.6,0.1l0.6,0l0.6,0.1l0.7,0.1 l-0.2,0.9l-0.4,0.4h-0.7l-0.9-0.3L197.7,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.8,107.8l-1,0.3l-0.8,0.3l-0.6,0.2l0.8,0.1l0.7,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.7,0.2l0.7,0.2 l0.1-1.1l-0.4-0.7l-0.7-0.3l-0.9,0L197.8,107.8z M120.5,97l-1.4,1.1l-1.4,1l0.5,0.1l0.5,0l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0l0.6,0 l0.5,0.1l0.5,0l0.6,0.1l0.6,0.1l1.1,0.1l0.6,0.1l0.6,0l0.6,0.1l0.5-0.7l0.6-0.8l0.7-1l0.9-1l0.9-1.1l1-1.1l1.1-1.1l1.1-1l1.2-1 l1.2-0.9l1.2-0.8l1.3-0.6l1.2-0.5l1.2-0.3l1.2-0.1l1.1,0.2l-2.2-0.8l-2.1-0.5l-1.9-0.1l-1.8,0.1l-1.8,0.4l-1.6,0.6l-1.6,0.8 l-1.5,0.9l-1.5,1.1l-1.4,1.2l-1.4,1.2l-1.4,1.3l-1.4,1.2L120.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.9,96.4l-1.5,1.8l-1.6,2l0.9,0.1l0.8,0.1l0.7,0.1l0.7,0.1l0.7,0.1l0.7,0.1l0.8,0.1l1,0.2l0.9-0.7 l0.8-0.8l0.9-0.8l0.8-0.8l1.7-1.7l0.8-0.8l0.8-0.8l0.8-0.8l0.9-0.7l0.8-0.7l0.9-0.7l0.9-0.6l1-0.5l1-0.5l1-0.5l-1.2-0.4l-1.2-0.3 l-1.1-0.2l-1.2-0.1l-1.1,0.1l-1.2,0.2l-1.1,0.3l-1.2,0.5l-1.2,0.7l-1.2,0.9l-1.3,1l-1.3,1.2l-1.4,1.4L129.9,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,99.3l-0.9,0.9l-0.9,0.7l5.4,0.6l0.7-0.8l0.7-0.8l0.6-0.8l0.7-0.8l0.7-0.8l0.7-0.8l1.4-1.6l1.6-1.5 l0.8-0.7l0.9-0.6l0.9-0.6l1-0.5l1-0.5l1.1-0.4l-0.9-0.8l-1-0.4l-1.1-0.1l-1.1,0.3l-1.2,0.5l-1.2,0.7l-1.3,0.9l-1.3,1l-1.3,1.1 l-1.3,1.2l-1.2,1.2l-1.2,1.2l-1.1,1.1L135,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.2,98.7l-1.2,1.4l-1.2,1.4l0.9,0.1l0.8,0l0.6,0.1l1.2,0.2l0.6,0.1l0.7,0.1l0.9,0.1l1-1.3l1-1.2l1-1.1 l1-0.9l1-0.8l1-0.7l0.9-0.6l1-0.5l0.9-0.4l0.9-0.3l0.9-0.2l0.9-0.2l0.8-0.1l0.8-0.1h0.8l0.8,0l-1.5-1.4l-1.4-1l-1.4-0.7l-1.4-0.4 l-1.4,0l-1.3,0.2l-1.3,0.5l-1.3,0.6l-1.3,0.9l-1.2,1l-1.3,1.2l-2.4,2.6L141.2,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.8,99.7l-1,1.2l-1,1.3l1,0.2l1.2,0.1l2.4,0.3l1.1,0.1l0.8,0.1l0.6,0l0.3,0l0.1-0.1l0.3-0.2l0.3-0.3 l0.4-0.4l0.5-0.5l0.6-0.6l0.7-0.6l0.8-0.7l0.9-0.6l1-0.7l1.1-0.6l1.2-0.6l1.2-0.6l1.3-0.5l1.3-0.5l1.4-0.3l-1.6-0.6l-1.5-0.4 l-1.5-0.3l-1.4-0.1l-1.4,0l-1.4,0.2l-1.3,0.3l-1.3,0.4l-1.3,0.5l-1.2,0.7l-1.2,0.8l-1.1,0.9l-1.1,1L146.8,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.1,101.2l-1,0.9l-0.9,0.9l0.6,0l0.8,0.1l1.8,0.2l0.9,0.1l0.8,0.1l0.7,0h0.5l0-0.1l0.2-0.3l0.5-0.3 l0.7-0.5l0.9-0.5l1-0.6l1.2-0.7l1.2-0.7l1.2-0.7l1.3-0.7l1.3-0.6l1.2-0.6l1.1-0.5l1-0.4l0.8-0.3l0.6-0.1l-1.3-0.5l-1.3-0.4 l-1.4-0.1l-1.4,0L166,95l-1.4,0.3l-1.4,0.4l-1.4,0.5l-1.3,0.6l-1.3,0.7l-2.6,1.7l-1.1,0.9L154.1,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.2,103.1l-0.6,0.4l-0.3,0.2l0.7,0.2l0.8,0.1l0.8,0.1l0.9,0l0.9,0.1l0.9,0.1l1.8,0.3l0.9-0.4l0.9-0.5 l0.9-0.5l0.9-0.5l0.9-0.4l0.9-0.5l0.9-0.5l0.9-0.5l0.9-0.5l0.9-0.5l0.9-0.4l0.9-0.4l0.9-0.5l0.9-0.4l0.9-0.4l0.9-0.3l-0.7-1.1 l-1-0.6l-1.3-0.2h-1.5l-1.6,0.3l-1.8,0.5l-1.9,0.7l-1.8,0.8l-1.9,0.9l-1.7,1l-1.6,0.9l-1.5,0.9l-1.2,0.8L159.2,103.1z  M171.3,104.5l-0.5,0.4l-0.3,0.3l0.8,0.1l0.7,0.1l0.6,0.1l0.6,0l0.7,0l0.6,0.1l0.7,0.1l0.8,0.1l0.7-0.4l0.7-0.5l0.7-0.5l0.7-0.5 l0.8-0.5l0.8-0.5l0.8-0.5l1.6-1l0.8-0.4l0.8-0.4l0.8-0.3l0.8-0.3l0.8-0.2h0.8l0.8,0l-1.1-0.8l-1.2-0.4l-1.3-0.2l-1.4,0l-1.4,0.3 l-1.5,0.5l-1.4,0.5l-1.4,0.6l-1.3,0.7l-1.3,0.7l-2.2,1.5l-0.9,0.6L171.3,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.3,102.5l-1.9,1l-2.1,1l0.8,0.1l0.9,0.1l0.9,0.1l0.9,0.1l0.8,0.1l0.6,0.1l0.4,0l0.2,0l0.1-0.1l0.4-0.3 l0.4-0.4l0.6-0.4l0.7-0.5l0.9-0.6l0.9-0.6l1-0.6l2.3-1.3l1.2-0.6l1.2-0.5l1.2-0.4l1.2-0.3l1.2-0.1l1.2,0l-0.8-0.5l-0.9-0.4 l-0.8-0.2l-0.9-0.1l-0.9,0l-0.9,0.2l-1,0.4l-1.1,0.4l-1.2,0.5l-1.2,0.6l-1.4,0.7l-1.5,0.8l-1.6,0.8L169.3,102.5z M178.3,104.4 l-1,0.7l-1,0.6l0.6,0.1l0.6,0.1l0.7,0.2l0.8,0.1l0.8,0.1l0.9,0.1l0.8,0.1l0.8,0.1l0.3-0.6l0.3-0.5l0.4-0.5l0.5-0.5l0.5-0.4 l0.5-0.4l0.6-0.4l0.6-0.3l0.7-0.3l0.7-0.2l0.7-0.1l0.8-0.1l0.8,0h0.8l1.7,0.2l-0.9-1l-0.9-0.7l-0.9-0.5l-1-0.3l-1,0l-1,0.1 l-1.1,0.3l-1,0.4l-1.1,0.5l-1,0.5l-1.1,0.7l-1.1,0.7l-1.1,0.7L178.3,104.4z M189,106.1l-0.5,0.5l-0.5,0.6l0.4,0.1l0.5,0.1 l0.5,0.1l0.5,0.1l0.5,0l0.4,0.1h0.4l0.2-0.1l0.5-0.3l0.8-0.4l1-0.4l1.1-0.4l1.3-0.4l1.2-0.2l1.2,0l-0.3-0.4l-0.4-0.3l-0.5-0.3 l-0.6-0.2l-0.7-0.1l-0.8,0h-0.8l-0.9,0l-0.8,0.1l-0.9,0.2l-0.8,0.3l-0.8,0.4l-0.7,0.4L189,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.6,107.5l-0.3,0.2l-0.1,0l4,0.7l0.4-0.1l0.5-0.2l0.6-0.2l0.7-0.2l0.7-0.1l0.7-0.1h0.6l0.5,0.1l0-0.8 l-0.2-0.6l-0.4-0.4l-0.5-0.2l-0.6-0.1l-0.7,0.1l-0.8,0.1l-0.9,0.2l-1.7,0.6l-0.8,0.3l-0.7,0.3l-0.6,0.3L191.6,107.5z  M183.4,104.9l-0.5,0.8l-0.4,0.9l0.6,0.1l0.6,0.1l0.6,0l0.7,0.1l0.7,0.1l0.7,0l0.8,0.2l0.8,0.1l0.3-0.4l0.3-0.4l0.4-0.3l0.4-0.4 l0.5-0.3l0.5-0.3l0.5-0.2l0.6-0.2l0.6-0.2l0.6-0.1l0.6-0.1l0.6-0.1l0.6,0h0.6l0.6,0.1l0.6,0.1l-0.8-0.6l-0.8-0.5l-0.9-0.4l-1-0.3 l-1-0.2l-1-0.1l-1.1,0l-1.1,0.1l-1,0.2l-1,0.4l-0.9,0.4l-0.9,0.5l-0.8,0.6L183.4,104.9z M18.2,93.5l1.2,0.7l1.6,0.5L20.7,94 l-0.2-0.8l-0.1-0.8l-0.1-0.9l-0.1-0.9v-0.9l0-0.9l0-0.9l0.1-0.9l0.1-0.9l0.2-0.9l0.2-0.8l0.1-0.8l0.2-0.7l0.3-0.7l0.2-0.6 l-0.2-0.1L21.2,81l-0.3-0.1l-0.2,0l-0.2-0.1l-0.2-0.1l-0.2-0.1l-0.3-0.1l-0.1,0.2l-0.3,0.4l-0.3,0.6l-0.4,0.8l-0.5,0.9l-0.5,1 l-0.4,1.2l-0.4,1.2l-0.3,1.2l-0.1,1.2l0.1,1.2l0.3,1.1l0.5,1L18.2,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1,98.3l0.5,0h0.5l-0.6-1.6l-0.2-0.9l-0.2-0.9l-0.2-1l-0.2-1l-0.2-1l-0.1-1l-0.1-1v-1.1l0.1-1l0.1-1.1 l0.1-1l0.2-1.1l0.3-1l0.3-1l-0.6-0.2l-0.6-0.2l-0.5-0.2l-0.5-0.1l-0.5-0.1l-0.5-0.1l-0.4-0.1l-0.4-0.1l-0.7,2.7l-0.5,2.5 l-0.3,2.1l0,1.9l0.1,1.6l0.3,1.4l0.4,1.2l0.5,1l0.6,0.8l0.6,0.6l0.6,0.5l0.6,0.3l0.7,0.3L25.1,98.3z M29.2,100.7l1.2,0.1l1.4-0.4 l-0.5-0.9l-0.5-0.9l-0.5-1L30,96.6l-0.3-1l-0.3-1l-0.2-1l-0.2-1l-0.1-1l-0.1-1.1v-1l0.1-1.1l0.1-1.1l0.2-1l0.2-1.1l0.3-1 l-0.5-0.2l-0.6-0.2l-1.8-0.6l-0.5-0.2l-0.4-0.2l-0.3-0.1l-0.3,1L25,84.7l-0.2,1.4l-0.1,1.5l-0.1,1.7l0,1.7l0.2,1.7l0.2,1.6 l0.4,1.5l0.4,1.4l0.6,1.2l0.7,1l0.9,0.7L29.2,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.1,87.1l0.3-1.6l0.4-1.5l0.5,0.2l0.6,0.2l0.6,0.1l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2v1l0,1.1 l0.1,1.3l0.1,2.7l0,1.4l0.2,1.4l0.1,1.3l0.2,1.3l0.2,1.2l0.3,1.2l0.3,1l0.4,0.9l0.5,0.7l0.5,0.5l0.6,0.3l-1.3,0.1l-1.3-0.2 l-1.1-0.5l-1-0.7l-1-0.9l-0.8-1.1l-0.7-1.3L30.2,97l-0.5-1.5l-0.4-1.6L29,92.1l-0.1-1.7l0-1.7L29.1,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,92.5l0,1.3l0.1,2.6l0.1,1.3l0.1,1.3l0.3,1.2l0.3,1.1l0.4,1l0.4,0.9l0.5,0.8l0.7,0.6l-1.4-0.3l-1.2-0.5 l-1-0.7l-0.8-0.8l-0.7-0.9l-0.5-1.1l-0.4-1.2l-0.3-1.2l-0.2-1.4L35,95.1L34.9,92l-0.1-3.2l0-1.6l-0.1-1.7l0.5,0.2l0.5,0.1 l0.4,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0.2l0.5,0.2l0.1,1l0.1,1.1l0.1,1.2l0,1.2L38.8,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,89.6l-0.1-1.5l-0.1-1.4l0.5,0.1l0.5,0.1l0.4,0.2l0.5,0.1l0.5,0.1l0.4,0.1l0.5,0.1l0.5,0.1L42.5,88 l-0.1,0.3l-0.1,0.5l-0.1,0.7L42,90.5l-0.1,1l-0.1,1.1l0.1,1.3l0.1,1.3l0.3,1.5l0.5,1.6l0.5,1.6l0.8,1.6l1,1.7l1.2,1.7l1.5,1.7 l-2-0.1l-1.7-0.4l-1.4-0.6l-1.1-0.8l-0.9-1.1l-0.7-1.2l-0.5-1.4l-0.4-1.5L39,97.8l-0.1-1.6l-0.1-1.7l0-3.3L38.8,89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.9,91.6l0.2-1.9l0.4-1.9l4.7,1.5l0,0.8l0,0.9l0,1l0.1,1.2l0.1,1.2l0.2,1.3l0.3,1.4l0.4,1.4l0.5,1.4 l0.5,1.4l0.6,1.4l0.7,1.3l0.8,1.3l0.9,1.2l1,1.1l1.1,0.9l-1.3,0.2l-1.3-0.1l-1.3-0.4l-1.3-0.7l-1.2-0.9l-1.2-1.1l-1.1-1.4l-1-1.5 l-0.8-1.6l-0.7-1.8l-0.6-1.9l-0.4-1.9L42,93.6L41.9,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,97.6l0.1,1.3l0.2,1.3l0.2,1.3l0.3,1.2l0.3,1.2l0.4,1.2l0.4,1.1l0.5,1l0.6,0.9l0.7,0.8l0.8,0.7l-1,0.1 l-1-0.1l-1-0.3l-1-0.4l-1-0.6l-1-0.8l-1-1l-1-1.2l-0.9-1.3l-0.8-1.6l-0.7-1.7l-0.6-2l-0.5-2.1l-0.4-2.3l-0.3-2.5l-0.1-2.7 l0.7,0.3l0.9,0.2l1,0.3l1.1,0.3l1,0.4l1,0.3l0.9,0.3l0.7,0.1l0.1,1.1l0.1,1.2l0.1,1.2l0,1.3L55.1,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.9,94.1l-0.1-1.4l-0.2-1.3l0.7,0.1l0.6,0.1l0.5,0.2L57,92l0.6,0.2l0.5,0.1l0.6,0.2l0.7,0.2l0.2,1.3 l0.1,1.3l0.2,1.3l0.2,1.2l0.2,1.2l0.2,1.2l0.3,1.1l0.3,1.1l0.3,1.1l0.4,1.1l0.5,1l0.5,1l0.7,1l0.7,1l0.9,0.9l1,0.9l-2.2,0.1 l-1.9-0.2l-1.6-0.5l-1.3-0.8l-1.1-1l-0.9-1.2l-0.6-1.4L56,104l-0.4-1.6l-0.3-1.7L55,97.3l0-1.7L54.9,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.9,95.4L59.7,94l-0.1-1.2l0.7,0.2l0.6,0.1l0.5,0.2l0.5,0.1l0.5,0.1l0.6,0.1l0.6,0.2l0.7,0.1l0.2,1.9 l0.3,1.8l0.4,1.7l0.3,1.6l0.4,1.4l0.4,1.4L67,105l0.5,1.1l0.5,1l0.6,0.9l0.6,0.8l0.5,0.7l0.6,0.7l0.6,0.5l0.6,0.5l0.6,0.4l-2,0.1 l-1.7-0.3l-1.5-0.5l-1.3-0.8l-1.1-1l-1-1.2l-0.8-1.4l-0.7-1.5l-0.6-1.6l-0.4-1.7l-0.4-1.6l-0.3-1.7L60,96.8L59.9,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.8,96.5l-0.2-1.3L64.4,94l0.6,0.1l0.6,0.2l0.6,0.1l0.6,0.2l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.2l0,0.9l0.2,1 l0.2,1.1l0.3,1.2l0.4,1.3l0.5,1.2l0.5,1.3l0.5,1.3l0.6,1.3l0.7,1.2l0.7,1.1l0.7,1.1l0.7,1l0.8,0.9L77,112l0.8,0.6l-1.9,0.1 l-1.7-0.3l-1.5-0.6l-1.4-0.8l-1.1-1l-1-1.2l-0.9-1.4l-0.8-1.5l-0.7-1.6l-0.5-1.6l-0.4-1.6l-0.4-1.6L65.1,98L64.8,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,96.5l-0.1-0.8l0-0.5l0.7,0.1l0.7,0.1l0.7,0.2l0.7,0.1l0.7,0.2l0.6,0.1l0.6,0.2l0.6,0.1l0.2,0.8 l0.6,2.1l0.4,1.3l0.4,1.3l0.4,1.4l0.5,1.4l0.6,1.4l0.6,1.4l0.6,1.3l0.7,1.2l0.7,1.1l0.8,0.9l0.8,0.7l0.9,0.5l1,0.3l-1.9,0.3 l-1.8-0.3l-1.6-0.6l-1.5-1l-1.4-1.2l-1.2-1.5l-1.1-1.7l-1-1.7l-0.8-1.8l-0.7-1.8l-0.6-1.7L69.9,99l-0.3-1.4L69.4,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.4,98.6l-0.3-1.2l-0.3-0.9l0.5,0.1l0.5,0l0.5,0.1l0.5,0.1l0.5,0.1l0.4,0.1l0.4,0.1l0.4,0.1l0.2,1.1 l0.3,1.2l0.3,1.2l0.3,1.1l0.4,1.2l0.4,1.1l0.5,1.1l1.2,2.2l0.7,1l0.8,1l0.8,0.9l0.9,0.9l0.9,0.8l1,0.7l1.1,0.7l-1.8,0.4l-1.6,0 l-1.4-0.3l-1.3-0.7l-1.1-0.9l-1-1.1l-0.9-1.4l-0.8-1.5l-0.7-1.6l-0.6-1.6l-0.5-1.6l-0.5-1.6l-0.4-1.5L75.4,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,100.8L79,99l-0.3-1.8l0.6,0.1l0.6,0.1l0.7,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.3,1l0.2,1.1 l0.3,1l0.3,1l0.3,1l0.3,1l0.4,1l0.4,1l0.5,1l0.6,1l0.7,1l0.9,1l1,0.9l1.2,1l1.4,1l1.5,0.9h-1.5l-1.4-0.1l-1.4-0.3l-1.3-0.5 l-1.2-0.7l-1.2-0.8l-1.1-1l-1.1-1.1l-0.9-1.2l-0.9-1.3l-0.8-1.5l-0.7-1.5l-0.6-1.6L79.4,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.6,101.8l-0.4-1.8l-0.3-1.8l0.5,0.1l0.6,0.2l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.2l0.2,1.2 l0.3,1.2l0.4,1.2l0.5,1.2l0.6,1.2l0.7,1.2l0.7,1.1l0.8,1.1l0.9,1.1l1,1l1,0.9l1.1,0.9l1.2,0.8l1.3,0.7l1.3,0.6l1.4,0.5l-1.9,0.2 l-1.9-0.1l-1.7-0.3l-1.6-0.5l-1.5-0.6l-1.4-0.8l-1.3-1l-1.2-1.2l-1.1-1.2l-1-1.4l-0.9-1.5l-0.7-1.6l-0.6-1.7L84.6,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.6,102.5l-0.5-1.6l-0.3-1.7l0.5,0.1l0.5,0l0.9,0.1l0.4,0l0.5,0.1l0.6,0.1l0.7,0.1l0.7,1.4l0.6,1.3 l1.1,2.5l0.6,1.1l0.6,1l0.6,1l0.6,0.9l0.7,0.9l0.8,0.8l0.9,0.9l1,0.8l1.1,0.8l1.3,0.8l1.4,0.8l1.6,0.8l-1.6-0.1l-1.6-0.3 l-1.6-0.4l-1.5-0.6l-1.4-0.7l-1.4-0.8l-1.3-0.9l-1.2-1.1l-1.1-1.2l-1.1-1.3l-0.9-1.4l-0.8-1.4l-0.7-1.5L89.6,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.3,102.8l-0.7-1.6l-0.6-1.5l0.4,0l0.6,0.1l1.5,0.2l0.8,0.1l0.7,0.1l0.6,0.1l0.5,0l0.6,1.4l0.6,1.4 l0.7,1.3l0.7,1.2l0.8,1.1l0.9,1.1l0.9,1l1,1l1,0.9l1.1,0.9l1.2,0.9l1.2,0.8l1.3,0.7l1.4,0.7l1.4,0.6l1.5,0.6l-2.4,0.1l-2.3-0.1 l-2-0.3l-1.9-0.5l-1.7-0.7l-1.5-0.9l-1.4-1l-1.3-1.2l-1.2-1.3l-1.1-1.4l-0.9-1.4l-0.9-1.6l-0.8-1.5L94.3,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.7,103.9l-0.9-1.7l-0.7-1.8l0.7,0.1l0.7,0.1l0.8,0l0.8,0.1l0.7,0l0.6,0.1l0.5,0.1l0.2,0.1l0.9,0.7 l0.9,0.7l1.9,1.8l0.9,1l1,1l1,1.1l1,1.1l1,1.1l2.1,2.2l1.1,1.1l1.1,1.1l1.1,1l1.1,1l1.1,0.9l-1.3,0l-1.4-0.2l-1.5-0.3l-1.5-0.5 l-1.5-0.6l-1.6-0.8l-1.5-0.9l-1.5-1l-1.5-1.2l-1.4-1.2l-1.3-1.4l-1.3-1.5l-1.1-1.5L99.7,103.9z M106.5,103.9l-1.6-1.5l-1.6-1.3 h0.6l0.6,0.1l0.7,0l0.7,0.2l0.8,0.1l0.8,0.1l0.7,0.1l0.6,0.1l2.5,2.3l1.2,1.2l1.2,1.2l1.1,1.2l1.1,1.2l1.1,1.2l1.1,1.1l1.1,1.1 l1.1,1l1,0.9l1,0.8l1,0.7l1,0.6l1,0.4l1,0.3l-1.3,0.8l-1.3,0.3l-1.3,0l-1.4-0.3l-1.4-0.7l-1.4-0.9l-1.4-1.2l-1.4-1.3l-2.9-3.1 l-3.1-3.4l-1.5-1.6L106.5,103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,104.1l-1.3-1.2l-1.4-1.2l0.5,0.1l0.6,0l0.7,0.1l0.7,0.1l0.7,0.1l0.6,0l0.5,0.1l0.3,0l0.8,0.2l0.8,0.4 l0.8,0.5l0.9,0.7l0.9,0.9l0.9,1l1,1.1l1,1.2l1.1,1.2l1.1,1.2l1.3,1.3l1.3,1.2l1.4,1.2l1.5,1.1l1.6,1l1.8,0.9l-2,0l-1.9-0.2 l-1.7-0.5l-1.7-0.6l-1.5-0.8l-1.4-1l-1.4-1.1l-1.3-1.2l-1.3-1.3l-1.2-1.3l-1.2-1.3l-2.5-2.8L111.7,104.1z M25.6,62.9l1.3-0.1 l1.5,0.4L28,63.7l-0.4,0.6L27.1,65l-0.4,0.8l-0.4,0.9l-0.4,0.9l-0.3,1l-0.4,1l-0.3,1l-0.3,1l-0.3,1l-0.3,1l-0.2,1l-0.2,0.9 l-0.1,0.8l-0.1,0.8l-0.3,0l-0.2,0l-0.3-0.1l-0.2,0L22.4,77l-0.2-0.1l-0.2,0l-0.3-0.1v-0.2L21.6,76l0-0.8l-0.1-1l-0.1-1.2l0.1-2.7 l0.1-1.4l0.3-1.3l0.4-1.3l0.5-1.1l0.7-0.9l0.8-0.7L25.6,62.9z M32.5,62.8l0.5,0.3l0.4,0.3L32.6,64l-0.7,0.7l-0.6,0.7l-0.6,0.8 L30.2,67l-0.5,0.8l-0.5,0.8l-0.4,0.9l-0.4,0.9l-0.8,2l-0.3,1l-0.3,1.1l-0.3,1.1l-0.3,1.1l-0.3,1.2L25.3,78l-0.4,0l-0.3-0.1 l-0.2-0.1l-0.2,0L24,77.6l-0.2-0.1l-0.3-0.1l0.6-3.2l0.7-2.7l0.7-2.3l0.7-1.9l0.7-1.6l0.7-1.2l0.7-0.9l0.6-0.6l0.7-0.5l0.6-0.2 l0.7-0.1l0.5,0.1l0.5,0.2L32.5,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.7,62.8l1.1,0.6l1.1,1.1l-0.9,0.6L37.2,66l-0.8,0.7l-0.7,0.7l-0.7,0.8l-0.6,0.9l-0.6,0.9L33.1,71l-0.5,1 l-0.4,1l-0.4,1l-0.3,1.1L31,76.2l-0.3,1.2l-0.3,1.2L30.3,80l-0.5-0.1l-0.6-0.2l-0.6-0.2l-0.6-0.2l-0.6-0.3l-0.5-0.2l-0.4-0.2 L26,78.4l0.1-1.2l0.3-1.3l0.4-1.5l0.5-1.6l0.6-1.6l0.7-1.6l0.8-1.5l0.9-1.4l0.9-1.3l1-1.1l1-0.8l1.1-0.6l1.1-0.2L36.7,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.2,76.3l-0.4,1.8l-0.2,1.8l1.2,0.3l0.6,0.2l0.6,0.2l0.6,0.3l0.6,0.1l0.6,0.2l0.6,0.1l0.4-1.1l0.4-1.2 l0.5-1.2l0.5-1.2l0.5-1.3l0.5-1.3l0.5-1.2l0.5-1.2l0.6-1.1l0.6-1l0.7-1l0.7-0.8l0.8-0.7l0.8-0.6l0.8-0.4l0.9-0.3l-1.2-0.8 L43,64.1L41.7,64l-1.2,0.1l-1.2,0.4l-1.2,0.6L37,66.1l-1.1,1l-1,1.2l-1,1.4L33,71.3l-0.7,1.6l-0.6,1.7L31.2,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.6,78.8L36,80.4l-0.6,1.4l0.5,0l0.5,0.1l0.5,0.1l0.5,0.2l0.5,0.2l0.5,0.2l0.5,0.1l0.5,0.1l0-0.2l0-0.5 l0.1-0.6l0.1-0.9l0.3-1l0.4-1.2l0.4-1.3l0.5-1.3l0.6-1.3l0.7-1.3l0.9-1.3l1-1.2l1.2-1.2l1.4-1l1.6-0.9l1.8-0.6L48.9,66l-1.7-0.4 l-1.5,0l-1.3,0.3l-1.2,0.5l-1,0.8l-0.9,1l-0.8,1.2l-0.7,1.4L39,72.4L38.4,74l-0.6,1.6l-0.6,1.6L36.6,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.4,78.8l-0.4,2l-0.3,2.2l5.1,1.3l0.3-0.8l0.4-1l0.4-1l0.5-1.1l0.6-1.2l0.6-1.2l0.7-1.2l0.7-1.2l0.8-1.2 l0.9-1.2l1-1.1l1-1l1.1-0.9l1.2-0.8l1.3-0.7l1.4-0.5l-1.1-0.8l-1.3-0.5L54,66.3l-1.4,0.1l-1.5,0.3l-1.5,0.6l-1.4,0.8l-1.4,1 l-1.4,1.2l-1.3,1.4L43,73.3L42,75l-0.9,1.8L40.4,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.6,80l0.6-1.3l0.6-1.3l0.6-1.3l0.7-1.2l0.7-1.1l0.8-1l0.8-0.9l0.8-0.8l0.9-0.7l1-0.5l1-0.4l-0.9-0.6 l-1-0.4l-1-0.3l-1.1-0.1L58.1,68l-1.2,0.3l-1.2,0.5l-1.3,0.7l-1.3,0.9l-1.3,1.2l-1.3,1.5l-1.2,1.7l-1.2,2l-1.2,2.2l-1.1,2.6 l-1,2.8l0.7,0.1l0.9,0.2l0.9,0.3l1,0.3l1,0.3l0.9,0.2l0.8,0.3l0.7,0.2l0.5-1.2l1.1-2.6l0.5-1.3L54.6,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.3,83.9l-0.6,1.5l-0.6,1.3l0.7,0.1l0.6,0.1l0.5,0.1l1.1,0.3l0.6,0.1l0.6,0.1l0.7,0.1l0.6-1.3l0.6-1.3 l0.6-1.3l0.6-1.2l0.6-1.2l0.6-1.1l0.6-1.1l0.6-1l0.7-1l0.8-0.9l0.8-0.9l0.9-0.8l1-0.8l1-0.7l1.2-0.6l1.2-0.6l-2-1.1l-1.8-0.6 l-1.7-0.1l-1.5,0.3l-1.3,0.6l-1.3,0.9l-1.1,1.1l-1,1.4l-0.9,1.5L56,77.1l-0.7,1.7l-0.7,1.7l-0.7,1.7L53.3,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.3,85.2l-0.6,1.4l-0.5,1.2l0.7,0.1l0.6,0.1l0.6,0.1l0.5,0.1l0.6,0.1l0.6,0.1l0.7,0.1l0.8,0.2l0.9-2 l0.9-1.8l0.8-1.7l0.8-1.6l0.8-1.4l0.7-1.2l1.5-2.1l0.8-0.8l0.8-0.7l0.8-0.6l0.8-0.5L73,74l0.9-0.3l0.9-0.2l1-0.1l-1.8-1l-1.7-0.5 l-1.6-0.1L69,72l-1.4,0.6l-1.4,0.9l-1.3,1.1l-1.2,1.3l-1.1,1.5l-1,1.5l-0.9,1.6l-0.8,1.6L59,83.8L58.3,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.5,86.5l-0.6,1.3l-0.5,1.2l0.6,0.1l0.5,0.1l0.6,0.1l0.5,0.2l0.5,0.1l0.5,0.1l0.6,0.1l0.6,0.1l0.3-1 l0.4-1.1l0.5-1.1l0.6-1.2l0.7-1.2l1.7-2.4l0.9-1.2l1-1.1l1-1.1l1-1l1-0.8l1.1-0.8l1-0.6l1-0.5l1-0.3l-1.8-0.8L77,73.4l-1.6,0 l-1.6,0.3l-1.4,0.6l-1.3,0.8l-1.2,1.1l-1.2,1.2l-1,1.4l-1,1.5l-0.9,1.5l-0.8,1.5L64.2,85L63.5,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,88.8L67,89.7l-0.1,0.5l0.7,0.1l0.6,0.1l1.9,0.4l0.6,0.1l0.6,0.1l0.6,0.1l0.4-0.8l0.5-1l0.6-1.1 l0.7-1.2l0.7-1.3l0.8-1.3l0.8-1.3l0.9-1.3l0.9-1.2l1-1.1l1-1l1-0.8l1.1-0.7l1.1-0.4L85,76l1.1,0l-1.8-1l-1.8-0.4l-1.8,0.1 L79,75.2L77.4,76l-1.6,1.1l-1.5,1.3L72.9,80l-1.3,1.6l-1.1,1.6l-1,1.6l-0.8,1.5l-0.7,1.3L67.3,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.4,89.1l-0.5,1.2l-0.5,1l0.6,0.1l0.5,0.1l0.4,0.1l0.4,0.1l0.4,0.1l0.4,0.1l0.4,0.1l0.4,0.1l0.4-1.2 l0.5-1.2l0.5-1.2l0.6-1.2l0.7-1.2l0.7-1.1l0.8-1.1l0.8-1l0.9-1l1-0.9l1-0.8l1.1-0.7l1.2-0.6l1.2-0.5l1.3-0.4l1.4-0.3l-1.6-1.1 L87,76l-1.5-0.1L84,76.1l-1.4,0.6l-1.3,0.9L80,78.7L78.8,80l-1.1,1.4l-1,1.5l-0.9,1.6l-0.9,1.6l-0.7,1.5L73.4,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,88.5l-0.9,1.8l-0.7,1.9l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.2l0.6,0.1l0.6,0.2l0.6,0.1l0.6,0.1l0.4-1.1 l0.4-1.1l0.5-1.1l0.4-1.1l0.5-1.1l0.5-1l0.6-1.1l0.7-1l0.8-0.9l0.9-0.9l1-0.8l1.1-0.8l1.3-0.7l1.4-0.6l1.6-0.6l1.8-0.4l-1.4-0.5 L92.5,78L91,77.9L89.6,78l-1.4,0.3l-1.3,0.4l-1.3,0.7l-1.3,0.8l-1.2,1l-1.2,1.2l-1.1,1.3l-1.1,1.4l-1,1.6L77.5,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.6,89.6l-0.8,1.8l-0.7,1.9l0.6,0.1l0.6,0.1l2,0.3l0.7,0.1l1.4,0.2l0.4-1.4l0.5-1.3l0.5-1.3l0.7-1.2 l0.7-1.1l0.8-1.1l0.9-1l1-0.9l1.1-0.9l1.2-0.7l1.2-0.7l1.3-0.6l1.4-0.4l1.4-0.4l1.5-0.3l1.5-0.1l-1.9-0.8L99,79.3L97.2,79l-1.7,0 l-1.6,0.3l-1.6,0.4l-1.5,0.6l-1.4,0.8l-1.3,1l-1.3,1.2l-1.1,1.3l-1.1,1.5l-1,1.6L82.6,89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.5,90.8l-0.6,1.7l-0.5,1.8l0.6,0l0.5,0l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.6,0.1l0.6,0.1l0.8-1.4l0.8-1.4 l0.7-1.2l0.6-1.2l0.7-1.1l0.6-1l0.6-1l0.7-0.9l0.8-0.8l0.9-0.7l1-0.7l1.1-0.6l1.3-0.6l1.4-0.5l1.6-0.4l1.8-0.4l-1.7-0.3l-1.6-0.1 l-1.6,0.1l-1.6,0.2l-1.6,0.4l-1.5,0.5l-1.4,0.6l-1.4,0.8l-1.3,0.9l-1.2,1.1l-1.1,1.2l-1,1.4l-0.9,1.5L87.5,90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.3,92.1l-0.8,1.6l-0.8,1.6l0.4,0l0.5,0l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.5,0l0.4,0.1l0.7-1.5l0.8-1.3 l0.9-1.3l0.9-1.2l1-1.1l1-1l1.1-0.9l1.2-0.9l1.2-0.8l1.3-0.7l1.3-0.6l1.4-0.6l1.4-0.5l1.5-0.5l1.6-0.4l1.6-0.4l-2.5-0.6l-2.3-0.3 l-2.1-0.1l-2,0.2l-1.8,0.4l-1.7,0.6l-1.5,0.7l-1.4,1L97.5,85l-1.2,1.2l-1.1,1.3l-1,1.4l-0.9,1.5L92.3,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,92.5l-1.1,1.7l-0.9,1.9l0.7,0.1l0.7,0.1l0.7,0.1l0.7,0.1l0.6,0.1l0.5,0.2l0.4,0l0.3,0l1-0.6l1-0.7 l1-0.8l1.1-0.9l1.1-0.9l1.1-1l1.2-1l1.2-1l1.2-1l1.2-1l1.3-1l1.3-0.9l1.3-0.9l1.3-0.8l1.4-0.8l1.3-0.7l-1.4-0.3l-1.4,0l-1.6,0.1 l-1.6,0.2l-1.6,0.4l-1.7,0.5l-1.7,0.6l-1.7,0.8l-1.7,0.9l-1.6,1.1l-1.5,1.2l-1.5,1.3l-1.3,1.5L97.3,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.3,94.4l-1.8,1.3l-1.8,1.2l0.5,0.1l0.6,0l0.8,0.1l0.8,0l0.8,0h2.2l1.3-1l2.6-2.1l1.2-1.1l1.2-1l1.1-1 l1.1-1l1.1-1l1.2-0.9l1.1-0.8l1.2-0.7l1.2-0.6l1.3-0.5l1.3-0.4l1.4-0.3l1.4-0.2l-1.2-1.2l-1.3-0.7l-1.4-0.3l-1.4,0.1l-1.5,0.4 l-1.6,0.7l-1.6,1l-1.7,1.1l-3.4,2.8l-1.7,1.6l-1.7,1.5l-1.8,1.6L103.3,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.1,95.5l-1.5,1.1l-1.5,1l0.5,0l0.6,0.1l0.7,0.1l0.7,0l0.7,0.1l0.6,0.1l0.5,0.1l0.3,0l0.9,0l0.9-0.3 l0.9-0.5l1-0.6l1-0.8l1.1-0.9l3.6-3.3l1.3-1.2l1.4-1.1l1.5-1.1l1.6-1l1.7-0.9l1.8-0.8l1.9-0.6l-2.1-0.5l-1.9-0.2l-1.8,0.1 l-1.7,0.4l-1.6,0.6l-1.6,0.7l-1.5,0.9l-1.5,1l-2.9,2.4l-1.4,1.3L111,93l-1.4,1.2L108.1,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.5,97.6l-1.1,0.5l-0.9,0.2l0.8,0.1l0.8,0.1l0.9,0.1l1,0.2l1,0.1l1,0.1l0.9,0l0.8,0l1.4-1l1.2-1l1.1-1 l1.1-0.9l1-0.9l0.9-0.9l1-0.9l0.9-0.8l0.9-0.8l1-0.7l1.1-0.7l1.2-0.6l1.3-0.6l1.4-0.5l1.6-0.5l1.7-0.4l-1.8-1l-1.9-0.4h-1.9 l-1.9,0.4l-1.9,0.7l-1.9,1l-1.9,1.2l-1.8,1.3l-1.7,1.5l-1.7,1.5l-1.6,1.4l-1.5,1.3l-1.3,1.1L112.5,97.6z M15.3,58l0.1-0.6 l0.1-0.5l-0.8,1l-0.6,1.1l-0.4,1.1l-0.3,1.1l-0.1,1.2v1.2l0.2,1.2l0.3,1.2l0.3,1.2l0.4,1.1l0.9,2.3l0.5,1.1l0.4,1.1l0.4,1l0.4,1 l-0.1-0.2l0-0.4L17,74v-0.4l0-0.6v-1.1l0-0.6l-0.1-0.6v-0.6l-0.1-0.7l-0.1-0.6l0-0.6l-0.1-0.6l-0.1-0.5l-0.2-0.5l-0.2-0.5 L16,65.3l-0.2-0.5l-0.1-0.5l-0.2-0.6L15.3,63l-0.1-0.6l-0.1-0.6l0-0.6l0-0.6l0-0.6l0-0.6l0-0.6L15.3,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,79.7l0.9-0.5l0.9-0.5l-0.8,0.8l-0.8,0.8L12.6,81l-0.8,0.7L11,82.5l-0.8,0.7l-0.8,0.7l-0.9,0.6 l-0.8,0.6l-0.9,0.5l-0.8,0.4l-0.9,0.4L4,86.8l-0.9,0.1l-0.9,0l-0.9,0l0.9-0.5l0.9-0.6L5,84.7l0.8-0.5l0.8-0.5l0.8-0.5l0.8-0.5 l0.8-0.5l0.8-0.5l0.8-0.5l0.8-0.5l0.8-0.5L13.2,79.7z M16.4,74.2l0.4,0.6l0.4,0.6l-0.2-0.6l-0.3-0.6l-0.3-0.7L16,72l-0.3-0.6 l-0.4-0.6l-0.4-0.6l-0.5-0.6L13.7,69l-0.6-0.5L12.4,68l-0.8-0.4l-0.8-0.3l-1-0.2l-1-0.1l0.7,0.4l0.6,0.4l0.6,0.4l1.2,0.9l0.5,0.5 l0.6,0.5l0.5,0.5l1.5,1.6l0.4,0.6l0.5,0.5L16.4,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1,73.9l0.2,0.9l0.2,0.9l0.1-1.1l0.1-1l0.2-2.2l0-1l0-1l-0.1-1l-0.1-1l-0.1-1l-0.2-0.9l-0.3-0.9l-0.3-0.8 L17.8,63l-0.5-0.7l-0.5-0.6l-0.6-0.5l0.2,1l0.1,1l0.2,1l0.2,0.9l0.1,0.9l0.1,0.9l0.1,0.9l0.1,0.9l0.1,0.9l0.2,0.9l0.1,0.8 l0.3,1.8L18.1,73.9z M15.6,73.2l0.6,0.7l0.5,0.5L16.6,73l-0.2-1.3l-0.3-1.1l-0.4-1l-0.4-0.8L14.8,68l-0.5-0.7l-0.6-0.6L13.3,66 l-0.6-0.6l-0.5-0.7l-0.4-0.8L11.4,63l-0.3-1l-0.3-1.2l-0.1-1.3l-0.9,0.8l-0.5,0.9l-0.3,1l-0.1,1l0.2,1l0.4,1.1l0.5,1.1l0.6,1.1 l0.7,1l0.8,1l0.8,1l0.8,0.9l0.8,0.9L15.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,62.2l0.3-0.9l0.4-0.9l-1.4,1.4l-1.2,1.3l-0.8,1.2l-0.6,1.2l-0.4,1.1l-0.2,1l0,1l0.1,0.9l0.3,0.9l0.2,0.8 l0.4,0.8l0.4,0.7l0.3,0.7l0.3,0.6l0.2,0.6l0.1,0.5v-1l0.1-1l0-1l0.1-1l0-0.9l0.1-0.9l0.1-0.9l0.1-0.9l0.2-0.9l0.1-0.9l0.3-0.9 l0.2-0.9l0.3-0.9L19,62.2z M13.5,79.1l0.8-0.1l0.7-0.1l-0.6,0.3l-0.6,0.2l-0.7,0.3L12.4,80l-0.7,0.3l-1.5,0.4l-0.8,0.1l-0.8,0.1 H7.7l-0.8-0.1L6,80.5l-0.8-0.3l-0.8-0.4l-0.8-0.5l-0.8-0.6L3.4,79l0.8,0.2l1.6,0.2l0.8,0l0.8,0h1.5l0.8-0.1h0.7l0.8-0.1l1.5-0.1 L13.5,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-0.4,86.5l-0.4,0.4l-0.4,0.4l0.3-1.2l0.5-1l0.6-0.9l0.8-0.8l0.9-0.7l1-0.6l1.1-0.5L5.3,81l2.4-0.8l1.2-0.3 l1.2-0.3l1.2-0.3l1.2-0.3l1.1-0.2l1.1-0.2l-0.5,0.2l-0.7,0.4l-0.9,0.6l-1.1,0.6l-1.1,0.7l-1.1,0.6l-1.1,0.6l-1,0.4l-0.6,0.1 L6.1,83l-0.6,0.1l-0.6,0.2l-0.6,0.3l-0.6,0.2L3.1,84l-0.6,0.3L2,84.6L1.4,85L1,85.3l-0.5,0.3L0,86.1L-0.4,86.5z M14.9,80l0.8-0.4 l0.6-0.4l-0.7,1.4L15,81.8l-0.7,0.9l-0.7,0.8l-0.7,0.6L12,84.8l-2.2,1.3l-0.7,0.5l-0.7,0.5l-0.7,0.6l-0.7,0.7l-0.7,0.9l-0.6,1 l-0.6,1.3l-0.4-1.1l-0.2-1.1l0.2-1.1l0.4-1l0.6-0.9l0.8-0.9l0.9-0.9l1-0.8L9.4,83l1.1-0.7l1.2-0.7l1.1-0.6l1-0.5L14.9,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.7,91.1L11.5,92L11.3,93l-0.5-1.9l-0.3-1.6L10.5,88l0.1-1.3l0.3-1.1l0.4-1l0.5-0.8l0.6-0.7l0.7-0.6 l0.7-0.5l0.7-0.4l0.7-0.4l0.6-0.4l0.6-0.3l0.8-0.7l-0.5,0.8l-0.5,0.8l-0.5,0.8l-0.5,0.8l-0.4,0.8l-0.4,0.8L14,85.3l-0.4,0.8 l-0.4,0.8l-0.3,0.8l-0.4,0.8l-0.3,0.8l-0.3,0.9L11.7,91.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-81.756 -228.435)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.6,333.3c-17.6-2.4-82.5-5.7-111.5-10.4c-23.3-3.8-46.1-10.7-67.8-18c-5.6-1.9-15.6-5.8-21.9-9.2 c-4-3.1-13.7-7.7-16.4-12c42.1,20,59,25.5,108.4,35.5C193.5,323.3,266.4,329.2,282.6,333.3L282.6,333.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.8804,
    y1: -286.2366,
    x2: 482.6303,
    y2: -305.7006,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M197.7,326.9l-1-0.6l-0.9-0.3l1.5,0.1l0.9,0.1l0.9,0.1l1.8,0.2l0.9,0l0.8,0.1l1.2,1.1l1.2,1.1l1,1.1l0.9,1.1 l0.9,1l1.7,2l1.8,1.9l0.9,0.8l1,0.8l1.1,0.8l1.2,0.7l1.3,0.7l1.5,0.6l1.7,0.5l-1.9,0.6l-1.8,0.2l-1.8-0.3l-1.8-0.7l-1.8-1 l-1.8-1.3l-1.7-1.5l-1.7-1.6l-1.6-1.6l-2.9-3.2l-1.3-1.5l-1.2-1.2L197.7,326.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.4984,
    y1: -300.7075,
    x2: 497.116,
    y2: -316.7152,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.1,329l-1.2-1.2l-1.3-1.1l0.5,0h0.5l0.5,0.1l1.1,0.1l0.5,0.1l0.5,0l0.5,0.1l0.5,0l0.6,0l0.5,0.1l1.8,0.1 h0.6l0.6,0.1l0.4,0.7l0.5,0.8l0.7,1l0.7,1l0.9,1.1l0.9,1.1l1,1.2l1,1.1l1.1,1.1l1.1,1l1.1,0.9l1.1,0.8l1.1,0.6l1.1,0.4l1,0.3h1 l-2.2,0.4l-2,0l-1.9-0.2l-1.8-0.4l-1.6-0.7l-1.5-0.8l-1.5-1l-1.3-1.1l-1.3-1.2l-1.2-1.3l-2.4-2.7l-1.2-1.3L205.1,329z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.1293,
    y1: -289.6786,
    x2: 510.7858,
    y2: -306.7554,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M214.1,331.3l-1.3-1.8l-1.4-2.1l0.8,0l0.8,0.1l0.8,0.1l0.8,0.1l0.8,0.1l0.8,0.1h1.8l0.8,0.8l0.7,0.8l0.7,0.8 l0.7,0.9l0.7,0.8l0.7,0.9l0.7,0.8l0.7,0.9l0.7,0.8l0.7,0.8l0.8,0.8l0.7,0.8l2.5,2.2l0.9,0.6l-1.2,0.2l-1.2,0.1l-1.1,0l-1.1-0.2 l-1.1-0.3l-1.1-0.4l-1.1-0.5l-1.1-0.7l-1.1-0.8l-1.1-1l-1.1-1.2l-1.2-1.3l-1.2-1.5L214.1,331.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.6182,
    y1: -299.7,
    x2: 523.2345,
    y2: -315.709,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.9,329.6l-0.9-0.9l-0.8-0.8l5.3,0.5l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8l0.6,0.8 l0.7,0.7l0.7,0.8l0.7,0.7l0.8,0.7l0.8,0.7l0.8,0.7l0.9,0.7l0.9,0.7l-0.9,0.5l-1,0.2l-1-0.2l-1.1-0.4l-1.1-0.6l-1.1-0.9l-1.1-1 l-1.1-1.2l-1.1-1.2l-1.1-1.3l-1-1.3l-1-1.2l-1-1.2L219.9,329.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.0252,
    y1: -291.7874,
    x2: 538.6557,
    y2: -308.1726,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.9,331.3l-1-1.5l-1-1.4l0.9,0.1l0.7,0l0.5,0l0.9,0.1l0.4,0l0.6,0l0.8,0l0.9,1.3l0.9,1.2l0.9,1.2l1,1 l1,0.9l1,0.9l1,0.8l1,0.7l1,0.6l1,0.5l0.9,0.4l0.9,0.3l0.9,0.3l0.8,0.2l0.8,0.1l0.7,0l-1.6,1l-1.4,0.6l-1.4,0.3h-1.4l-1.3-0.2 l-1.3-0.4L234,340l-1.2-0.9l-1.2-1.1l-1.2-1.1l-1.1-1.3l-1.1-1.3l-1.1-1.4L225.9,331.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.7933,
    y1: -298.6939,
    x2: 549.4096,
    y2: -314.7016,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M230.7,331.3l-0.9-1.2l-0.9-1.3l1,0.1l1.1,0.1l1,0.1l1,0l0.9,0.1l0.7,0l0.5,0.1l0.2,0l0.1,0.1l0.3,0.3 l0.4,0.4l0.5,0.5l0.5,0.6l0.7,0.7l0.7,0.7l0.8,0.8l0.9,0.8l1,0.8l1,0.8l1.1,0.8l1.1,0.7l1.1,0.7l1.2,0.6l1.2,0.5l-1.6,0.2 l-1.5,0.1l-1.5-0.1l-1.4-0.2l-1.3-0.3l-1.3-0.4l-1.2-0.5l-1.2-0.7l-1.2-0.7l-1.1-0.8l-1.1-0.9l-1-1l-1-1.1L230.7,331.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 562.3454,
    y1: -293.9681,
    x2: 562.8799,
    y2: -307.857,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M237.2,331.3l-0.9-1l-0.8-1h0.6l0.7,0.1l0.8,0h0.8l0.8,0.1l0.8,0.1l0.6,0.1l0.5,0.1v0.1l0.2,0.3l0.5,0.5 l0.7,0.5l0.8,0.7l1,0.8l1.1,0.8l1.1,0.8l1.2,0.9l1.2,0.9l1.1,0.8l1.1,0.7l1,0.7l0.9,0.5l0.7,0.4l0.5,0.2l-1.3,0.2l-1.3,0.1 l-1.3-0.1l-1.3-0.3l-1.3-0.4l-1.3-0.5l-1.3-0.6l-1.3-0.8l-1.2-0.8l-1.2-0.9l-1.1-0.9l-1.1-1l-1-1L237.2,331.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 576.0141,
    y1: -297.6438,
    x2: 576.6304,
    y2: -313.6528,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M241.8,330.5l-0.5-0.5l-0.2-0.2l0.6,0l0.7,0l0.7,0l0.7,0.1l0.8,0.1l1.6,0.1l0.8,0l0.9,0.5l0.9,0.5l0.9,0.6 l0.8,0.6l0.9,0.6l0.8,0.6l0.9,0.6l0.8,0.6l1.8,1.2l0.9,0.6l0.8,0.6l1.8,1.1l0.8,0.5l0.9,0.5l-0.8,0.8l-1,0.3l-1.3,0l-1.4-0.3 l-1.6-0.6l-1.6-0.8l-1.7-1l-1.7-1.1l-1.7-1.2l-1.6-1.2l-1.5-1.1l-1.3-1.1l-1.1-0.9L241.8,330.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.1606,
    y1: -292.0456,
    x2: 588.3254,
    y2: -299.5071,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M251,332.7l-1.8-1.2l-2-1.2l0.8,0.1l0.9,0.1l0.8,0l0.8,0l0.7,0l0.6,0l0.4,0.1l0.2,0l0.1,0.1l0.3,0.3 l0.4,0.4l0.6,0.5l0.7,0.6l0.8,0.7l0.9,0.7l2.1,1.6l1.1,0.8l1.1,0.7l1.1,0.7l1.1,0.6l1.1,0.5l1,0.3l0.9,0.2l-0.8,0.3l-0.8,0.2 l-0.8,0l-0.8-0.1l-0.8-0.3l-0.9-0.3l-0.9-0.5l-1-0.6l-1.1-0.7l-1.1-0.8l-1.2-0.9l-1.4-0.9l-1.5-1L251,332.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.4819,
    y1: -282.5983,
    x2: 600.0596,
    y2: -298.7941,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M253.3,331.4l-0.5-0.4l-0.3-0.3l0.8,0l0.7,0.1l0.7,0l0.7,0.1l0.7,0.1l0.7,0l0.8,0.1l0.8,0l0.6,0.5l0.6,0.5 l0.6,0.5l0.6,0.6l0.6,0.6l0.6,0.6l0.7,0.6l0.7,0.6l1.4,1.1l0.7,0.5l0.7,0.4l0.8,0.4l0.7,0.3l0.8,0.3l0.8,0.2l-1.1,0.4l-1.2,0.2 l-1.3-0.1l-1.3-0.3l-1.4-0.5l-1.3-0.6l-1.4-0.8l-1.3-0.9l-1.2-0.9l-1.2-0.9l-1.1-0.9l-0.9-0.9l-0.8-0.7L253.3,331.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 609.3084,
    y1: -291.5782,
    x2: 609.4732,
    y2: -299.041,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M260.5,332.7l-0.9-0.8l-0.9-0.8l0.5,0.1l0.6,0.1l1.3,0.1l0.7,0.1l0.8,0.1l0.8,0.1l0.8,0l0.2,0.6l0.3,0.6 l0.4,0.5l0.4,0.5l0.5,0.5l1.1,1l0.6,0.4l0.6,0.4l0.7,0.3l0.7,0.3l0.7,0.3l0.8,0.2l0.8,0.2l0.8,0.1l0.8,0.1l-1,0.7l-1,0.4l-1,0.2 l-1,0.1l-1-0.2l-1-0.3l-1-0.4l-1-0.6l-0.9-0.6l-1-0.8l-0.9-0.8l-1.9-1.7L260.5,332.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 623.9008,
    y1: -285.7996,
    x2: 621.4785,
    y2: -301.9967,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M265.2,333.3l-0.4-0.8l-0.3-0.8l0.6,0.1l0.6,0l0.6,0.1l1.3,0.1l0.7,0l0.7,0.1l0.8,0l0.3,0.5l0.4,0.5 l0.4,0.4l0.4,0.4l0.4,0.4l0.5,0.3l0.4,0.4l0.5,0.3l0.5,0.3l1.1,0.5l0.6,0.2l0.6,0.2l0.6,0.2l0.7,0.1l0.7,0.2l-0.8,0.3l-0.9,0.3 l-0.9,0.1l-1,0l-1,0l-1.1-0.1l-1-0.3l-1-0.3l-1-0.4l-0.9-0.5l-0.8-0.5l-0.8-0.6l-0.7-0.7L265.2,333.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 628.1079,
    y1: -291.1612,
    x2: 628.2726,
    y2: -298.6241,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M270.7,333.2l-0.4-0.6l-0.4-0.6l0.8,0.1l0.5,0l0.4,0l0.8,0.1h0.7v0.2l0.4,0.4l0.7,0.5l1,0.6l2.4,1.3 l1.2,0.5l1,0.3l-0.3,0.3l-0.5,0.2l-0.5,0.1h-0.6l-0.7,0l-0.7-0.1l-0.8-0.3l-0.8-0.3l-0.8-0.4l-0.8-0.4l-0.8-0.4l-0.7-0.5 l-0.7-0.5L270.7,333.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.1875,
    y1: -291.0517,
    x2: 633.3522,
    y2: -298.5145,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273.4,332.6l-0.3-0.2l0-0.1l3.9,0.4l0.3,0.2l0.5,0.3l0.6,0.3l0.6,0.3l0.7,0.3l0.6,0.3l0.6,0.2l0.5,0.1 l-0.1,0.7l-0.2,0.4l-0.4,0.2l-0.5,0.1l-0.6-0.1l-0.7-0.3l-0.7-0.3l-0.8-0.4l-0.8-0.4l-1.5-1l-0.6-0.5l-0.5-0.4L273.4,332.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 638.8893,
    y1: -301.9908,
    x2: 638.9944,
    y2: -306.7925,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M279.5,334l-0.9-0.5l-0.8-0.4l-0.7-0.3l0.8,0.1l0.7,0.1l0.7,0l0.6,0l0.6,0.1l0.6,0l0.6,0.1l0.7,0.1 l-0.2,0.9l-0.4,0.4l-0.7,0l-0.9-0.3L279.5,334z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 639.0047,
    y1: -290.9211,
    x2: 639.1695,
    y2: -298.3839,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M279.6,331.5l-1,0.3l-0.8,0.3l-0.6,0.2l0.8,0.1l0.7,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.2l0.7,0.2l0.7,0.2 l0.1-1.1l-0.4-0.7l-0.7-0.2l-0.9,0L279.6,331.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.9531,
    y1: -297.5394,
    x2: 491.8489,
    y2: -274.7514,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M202.3,320.7l-1.4,1.1l-1.4,1l0.5,0.1l0.5,0l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0l0.6,0l0.5,0.1l0.5,0l0.6,0.1 l0.6,0.1l1.1,0.1l0.6,0.1l0.6,0l0.6,0.1l0.5-0.7l0.6-0.8l0.7-1l0.9-1l0.9-1.1l1-1.1l1.1-1.1l1.1-1l1.2-1l1.2-0.9l1.2-0.8l1.3-0.6 l1.2-0.5l1.2-0.3l1.2-0.1l1.1,0.2l-2.2-0.8l-2.1-0.5l-1.9-0.1l-1.8,0.1l-1.8,0.4l-1.6,0.6l-1.6,0.8l-1.5,0.9l-1.5,1.1l-1.4,1.2 l-1.4,1.2l-1.4,1.3l-1.4,1.2L202.3,320.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.0236,
    y1: -274.0138,
    x2: 519.3932,
    y2: -255.8809,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M211.8,320.1l-1.5,1.8l-1.6,2l0.9,0.1l0.8,0.1l0.7,0.1l1.4,0.2l0.7,0.1l0.8,0.1l1,0.2l0.9-0.7l0.8-0.8 l0.9-0.8l0.8-0.8l1.7-1.7l0.8-0.8l0.8-0.8l0.8-0.8l0.9-0.7l0.8-0.7l0.9-0.7l0.9-0.6l1-0.5l1-0.5l1-0.5l-1.2-0.4l-1.2-0.3 l-1.1-0.2l-1.2-0.1l-1.1,0.1l-1.2,0.3l-1.1,0.3l-1.2,0.5l-1.2,0.7l-1.2,0.9l-1.3,1l-1.3,1.2l-1.4,1.4L211.8,320.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.3595,
    y1: -304.9227,
    x2: 516.2553,
    y2: -282.1347,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M216.8,323.1l-0.9,0.9l-0.9,0.7l5.4,0.6l0.7-0.8l0.7-0.8l0.6-0.8l0.7-0.8l0.7-0.8l0.7-0.8l0.7-0.8l0.7-0.7 l0.8-0.7l0.8-0.7l0.8-0.7l0.9-0.6l0.9-0.6l1-0.5l1-0.5l1.1-0.4l-0.9-0.8l-1-0.4l-1.1-0.1l-1.1,0.3l-1.2,0.5l-1.2,0.7l-1.3,0.9 l-1.3,1l-1.3,1.1l-1.3,1.2l-1.2,1.2l-1.2,1.2l-1.1,1.1L216.8,323.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.0803,
    y1: -288.3781,
    x2: 540.4513,
    y2: -270.2465,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M223,322.4l-2.4,2.9l0.9,0.1l0.8,0l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.7,0.1l0.9,0.1l1-1.3l1-1.2l1-1.1 l1-0.9l1-0.8l1-0.7l0.9-0.6l1-0.5l0.9-0.4l0.9-0.3l0.9-0.3l0.9-0.2l0.8-0.1l0.8-0.1h0.8l0.8,0L240,316l-1.4-1l-1.4-0.7l-1.4-0.4 l-1.4,0l-1.3,0.2l-1.3,0.5l-1.3,0.6l-1.3,0.9l-1.2,1l-1.3,1.2l-2.4,2.6L223,322.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.6593,
    y1: -313.1855,
    x2: 543.5565,
    y2: -290.3974,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M228.6,323.4l-1,1.2l-1,1.3l1,0.1l1.2,0.1l2.4,0.3l1.1,0.1l0.8,0.1l0.6,0l0.3,0l0.1-0.1l0.3-0.2l0.3-0.3 l0.4-0.4l0.5-0.5l0.6-0.6l0.7-0.6l0.8-0.7l0.9-0.6l1-0.7l1.1-0.6l1.2-0.6l1.2-0.6l1.3-0.5l1.3-0.5l1.4-0.3l-1.6-0.6l-1.5-0.4 l-1.5-0.3l-1.4-0.1h-1.4l-1.4,0.2l-1.3,0.3l-1.3,0.5l-1.3,0.5l-1.2,0.7l-1.2,0.8l-1.1,0.9l-1.1,1L228.6,323.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 549.6816,
    y1: -303.1173,
    x2: 562.0526,
    y2: -284.9844,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M235.9,324.9l-1,0.9l-0.9,0.9l0.6,0l0.8,0.1l0.9,0.1l1.9,0.2l0.8,0.1l0.7,0h0.5v-0.1l0.2-0.2l0.5-0.3 l0.7-0.5l0.9-0.5l1-0.6l1.2-0.7l1.2-0.7l1.2-0.7l1.3-0.7l2.5-1.2l1.1-0.5l1-0.4l0.8-0.3l0.6-0.2l-1.3-0.5l-1.3-0.4l-1.4-0.1 l-1.4,0l-1.4,0.2l-1.4,0.3l-1.4,0.4l-1.4,0.5l-1.3,0.6l-1.3,0.7l-2.6,1.7l-1.1,0.9L235.9,324.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 565.6788,
    y1: -321.9685,
    x2: 572.5746,
    y2: -299.1805,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M241,326.9l-0.6,0.4l-0.3,0.2l0.7,0.2l0.8,0.1l0.8,0.1l0.9,0.1l0.9,0.1l0.9,0.1l1.8,0.3l0.9-0.4l0.9-0.5 l0.9-0.5l0.9-0.5l0.9-0.4l0.9-0.5l0.9-0.5l0.9-0.5l0.9-0.5l0.9-0.5l0.9-0.4l0.9-0.4l0.9-0.5l0.9-0.4l0.9-0.4l0.9-0.3l-0.7-1.1 l-1-0.6l-1.3-0.2h-1.5l-1.6,0.3l-1.8,0.5l-1.9,0.7l-1.8,0.8l-1.9,0.9l-1.7,1l-1.6,0.9l-1.5,0.9l-1.2,0.8L241,326.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 598.9142,
    y1: -291.8061,
    x2: 599.079,
    y2: -299.269,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M253.1,328.2l-0.5,0.4l-0.3,0.3l0.8,0.1l0.7,0.1l0.6,0.1l0.6,0l0.7,0l0.6,0.1l0.7,0.1l0.8,0.1l0.7-0.4 l0.7-0.5l0.7-0.5l0.7-0.5l0.8-0.5l0.8-0.5l0.8-0.5l1.6-1l0.8-0.4l0.8-0.4l0.8-0.3l0.8-0.3l0.8-0.2h0.8l0.8,0l-1.1-0.8l-1.2-0.4 l-1.3-0.2h-1.4l-1.4,0.3l-1.5,0.5l-1.4,0.5l-1.4,0.6l-2.7,1.5l-2.2,1.5l-0.9,0.6L253.1,328.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 590.9717,
    y1: -280.8764,
    x2: 588.5494,
    y2: -297.0722,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M251.1,326.3l-1.9,1l-2.1,1l0.8,0.1l0.9,0.1l0.9,0.1l0.9,0.1l0.8,0.1l0.6,0.1l0.4,0l0.2,0l0.1-0.1l0.4-0.3 l0.4-0.4l0.6-0.4l0.7-0.5l0.9-0.6l0.9-0.6l1-0.6l1.1-0.6l1.1-0.6l1.2-0.6l1.2-0.5l1.2-0.4l1.2-0.3l1.2-0.1l1.2,0l-0.8-0.5 l-0.9-0.4l-0.8-0.2l-0.9-0.1l-0.9,0l-0.9,0.2l-1,0.4l-1.1,0.4l-1.2,0.5l-1.2,0.6l-1.4,0.7l-1.5,0.8l-1.6,0.8L251.1,326.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 611.261,
    y1: -283.9113,
    x2: 608.8387,
    y2: -300.1071,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M260.1,328.1l-1,0.7l-1,0.6l0.6,0.1l0.6,0l0.7,0.2l0.8,0.1l0.8,0.1l0.9,0.1l0.8,0.1l0.8,0.1l0.3-0.6 l0.4-0.5l0.4-0.5l0.5-0.5l0.5-0.4l0.5-0.4l0.6-0.4l0.6-0.3l0.7-0.3l0.7-0.2l0.7-0.1l0.8-0.1l0.8,0l0.8,0l1.7,0.2l-0.9-1l-0.9-0.7 l-0.9-0.5l-1-0.3l-1,0l-1,0.1l-1.1,0.2l-1,0.4l-1.1,0.5l-1,0.5l-1.1,0.7l-1.1,0.7l-1.1,0.7L260.1,328.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 631.0585,
    y1: -286.8725,
    x2: 628.6362,
    y2: -303.0683,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M270.8,329.8l-0.5,0.5l-0.5,0.6l0.4,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0l0.4,0.1h0.4l0.2-0.1l0.5-0.3 l0.8-0.4l1-0.4l1.1-0.4l1.3-0.3l1.2-0.2l1.2,0l-0.3-0.4l-0.4-0.3l-0.5-0.3l-0.6-0.2l-0.7-0.1l-0.8,0h-0.8l-0.9,0l-0.8,0.1 l-0.9,0.2l-0.8,0.3l-0.8,0.4l-0.7,0.4L270.8,329.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.6744,
    y1: -291.0403,
    x2: 633.8392,
    y2: -298.5032,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M273.4,331.3l-0.3,0.2l-0.1,0l4,0.7l0.4-0.1l0.5-0.2l0.6-0.2l0.7-0.2l0.7-0.1l0.7-0.1l0.6,0l0.5,0.1l0-0.8 l-0.2-0.6l-0.4-0.4l-0.5-0.3l-0.6-0.1l-0.7,0.1l-0.8,0.1l-0.9,0.2l-0.8,0.3l-0.8,0.3l-0.8,0.3l-0.7,0.3l-0.6,0.3L273.4,331.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 620.4952,
    y1: -291.3307,
    x2: 620.66,
    y2: -298.7935,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E57E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#F7DB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#F3C87A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F2C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F5D17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M265.2,328.6l-0.5,0.8l-0.4,0.9l0.6,0.1l0.6,0.1l0.6,0l0.7,0.1l0.7,0.1l0.7,0l0.8,0.1l0.8,0.1l0.3-0.4 l0.3-0.4l0.4-0.3l0.4-0.4l0.5-0.3l0.5-0.3l0.5-0.3l0.6-0.2l0.6-0.2l0.6-0.2l0.6-0.1l0.6-0.1l0.6,0l0.6,0l0.6,0l0.6,0.1l-0.8-0.6 l-0.8-0.5l-0.9-0.4l-1-0.3l-1-0.2l-1-0.1l-1.1,0l-1.1,0.1l-1,0.2l-1,0.4l-0.9,0.4l-0.9,0.5l-0.8,0.6L265.2,328.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.663,
    y1: -246.5982,
    x2: 250.2385,
    y2: -262.6111,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M100,317.2l1.2,0.7l1.6,0.5l-0.3-0.7l-0.2-0.8l-0.1-0.8l-0.1-0.9l-0.1-0.9v-0.9l0-0.9l0-0.9l0.1-0.9 l0.1-0.9l0.2-0.9l0.2-0.8l0.1-0.8l0.2-0.7l0.3-0.7l0.2-0.6l-0.3-0.1l-0.2-0.1l-0.3-0.1l-0.2,0l-0.2-0.1l-0.2-0.1l-0.2-0.1 l-0.3-0.1l-0.1,0.2l-0.3,0.4l-0.3,0.6l-0.4,0.8l-0.5,0.9l-0.5,1l-0.4,1.2l-0.4,1.2l-0.3,1.2l-0.1,1.2l0.1,1.2l0.3,1.1l0.5,1 L100,317.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.7096,
    y1: -249.6647,
    x2: 259.285,
    y2: -265.6775,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M106.9,322l0.5,0h0.5l-0.6-1.6l-0.2-0.9l-0.2-0.9l-0.2-1l-0.2-1l-0.2-1l-0.1-1l-0.1-1v-1.1l0.1-1l0.1-1.1 l0.1-1l0.2-1.1l0.3-1l0.3-1l-0.6-0.2l-0.6-0.2l-0.5-0.2l-0.5-0.1l-0.5-0.1l-0.5-0.2l-0.4-0.1l-0.4-0.1l-0.7,2.7l-0.5,2.5 l-0.3,2.1l0,1.9l0.1,1.6l0.3,1.4l0.4,1.2l0.5,1l0.6,0.8l0.6,0.6l0.6,0.5l0.6,0.3l0.7,0.2L106.9,322z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.3415,
    y1: -253.2651,
    x2: 269.917,
    y2: -269.2779,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M111,324.4l1.2,0.1l1.4-0.4l-0.5-0.9l-0.5-0.9l-0.5-1l-0.4-0.9l-0.3-1l-0.3-1l-0.2-1l-0.2-1l-0.1-1l0-1.1 v-1l0.1-1.1l0.1-1.1l0.2-1l0.2-1.1l0.3-1l-0.5-0.2l-1.2-0.4l-0.6-0.2l-0.6-0.2l-0.5-0.2l-0.4-0.2l-0.3-0.1l-0.3,1l-0.3,1.2 l-0.2,1.4l-0.1,1.5l-0.1,1.7l0,1.7l0.2,1.7l0.2,1.6l0.4,1.5l0.4,1.4l0.6,1.2l0.7,1l0.9,0.7L111,324.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.9974,
    y1: -257.2135,
    x2: 281.5716,
    y2: -273.2263,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M110.9,310.8l0.3-1.6l0.4-1.5l0.5,0.2l0.6,0.2l0.6,0.1l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2v1l0,1.1 l0.1,1.3l0.1,2.7l0,1.4l0.2,1.4l0.1,1.3l0.2,1.3l0.2,1.2l0.3,1.2l0.3,1l0.4,0.9l0.5,0.7l0.5,0.5l0.6,0.3l-1.3,0.1l-1.3-0.2 l-1.1-0.5l-1-0.7l-1-0.9l-0.8-1.1l-0.7-1.3l-0.6-1.4l-0.5-1.5l-0.4-1.6l-0.2-1.7l-0.1-1.7l0-1.7L110.9,310.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.0903,
    y1: -252.6429,
    x2: 291.5431,
    y2: -272.8504,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    style: {
      stopColor: "#863893"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    style: {
      stopColor: "#9D398F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    style: {
      stopColor: "#C13A88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#EC3C80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M120.6,316.2v1.3l0.1,2.6l0.1,1.3l0.1,1.3l0.3,1.2l0.3,1.1l0.4,1l0.4,0.9l0.5,0.8l0.7,0.6l-1.4-0.3 l-1.2-0.5l-1-0.7l-0.8-0.8l-0.7-0.9l-0.5-1.1l-0.4-1.2l-0.3-1.2l-0.2-1.4l-0.1-1.4l-0.1-3.1l-0.1-3.2l0-1.6l-0.1-1.7l0.5,0.2 l0.5,0.1l0.4,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0.2l0.5,0.2l0.1,1l0.1,1.1l0.1,1.2l0,1.2L120.6,316.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.8737,
    y1: -272.7421,
    x2: 301.0702,
    y2: -285.1273,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M120.6,313.3l-0.1-1.5l-0.1-1.4l0.5,0.1l0.5,0.1l0.4,0.2l0.5,0.1l0.5,0.1l0.4,0.1l0.5,0.1l0.5,0.1l-0.1,0.1 l-0.1,0.4l-0.1,0.5l-0.1,0.7l-0.1,0.9l-0.1,1l-0.1,1.1l0.1,1.3l0.1,1.3l0.3,1.5l0.5,1.6l0.5,1.6l0.8,1.6l1,1.7l1.2,1.7l1.5,1.7 l-2-0.1l-1.7-0.4l-1.4-0.6l-1.1-0.8l-0.9-1.1l-0.7-1.2l-0.5-1.4l-0.4-1.5l-0.2-1.6l-0.1-1.6l-0.1-1.7l0-3.3L120.6,313.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.6407,
    y1: -274.4545,
    x2: 312.8386,
    y2: -286.8398,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M123.7,315.3l0.2-1.9l0.4-1.9l4.7,1.5l0,0.8l0,0.9l0,1l0.1,1.2l0.1,1.2l0.2,1.3l0.3,1.4l0.4,1.4l0.5,1.4 l0.5,1.4l0.6,1.4l0.7,1.3l0.8,1.3l0.9,1.2l1,1.1l1.1,0.9l-1.3,0.2l-1.3-0.1l-1.3-0.4l-1.3-0.7l-1.2-0.9l-1.2-1.1l-1.1-1.4l-1-1.5 l-0.8-1.6l-0.7-1.8l-0.6-1.9l-0.4-1.9l-0.2-1.9L123.7,315.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.3996,
    y1: -273.111,
    x2: 322.5647,
    y2: -300.4556,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M136.9,321.3l0.1,1.3l0.2,1.3l0.2,1.3l0.3,1.2l0.3,1.2l0.4,1.2l0.4,1.1l0.5,1l0.6,0.9l0.7,0.8l0.8,0.7 l-1,0.1l-1,0l-1-0.3l-1-0.4l-1-0.6l-1-0.8l-1-1l-1-1.2l-0.9-1.3l-0.8-1.6l-0.7-1.7l-0.6-2l-0.5-2.1l-0.4-2.3l-0.3-2.5l-0.1-2.7 l0.7,0.3l0.9,0.3l1,0.3l1.1,0.3l1,0.4l1,0.3l0.9,0.3l0.7,0.1l0.1,1.1l0.1,1.2l0.1,1.2l0,1.3L136.9,321.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.9467,
    y1: -278.2833,
    x2: 339.1432,
    y2: -290.6685,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M136.7,317.8l-0.1-1.4l-0.2-1.3l0.7,0.1l0.6,0.2l0.5,0.2l0.5,0.1l0.6,0.2l0.5,0.1l0.6,0.2l0.7,0.2l0.2,1.3 l0.1,1.3l0.2,1.3l0.2,1.2l0.2,1.2l0.2,1.2l0.3,1.1l0.3,1.1l0.3,1.1l0.4,1.1l0.5,1l0.5,1l0.7,1l0.7,1l0.9,0.9l1,0.9l-2.2,0.1 l-1.9-0.2l-1.6-0.5l-1.3-0.8l-1.1-1l-0.9-1.2l-0.6-1.4l-0.5-1.6l-0.4-1.6l-0.3-1.7l-0.3-3.4l0-1.7L136.7,317.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.9951,
    y1: -275.9748,
    x2: 350.1602,
    y2: -303.3181,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M141.7,319.1l-0.2-1.4l-0.1-1.2l0.7,0.2l0.6,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.6,0.1l0.6,0.2l0.7,0.1l0.2,1.9 l0.3,1.8l0.4,1.7l0.4,1.6l0.4,1.4l0.4,1.4l0.5,1.2l0.5,1.1l0.5,1l0.6,0.9l0.6,0.8l0.5,0.7l0.6,0.7l0.6,0.5l0.6,0.5l0.6,0.4 l-2,0.1l-1.7-0.2l-1.5-0.5l-1.3-0.8l-1.1-1l-1-1.2l-0.8-1.4l-0.7-1.5l-0.6-1.6l-0.4-1.7l-0.4-1.6l-0.3-1.7l-0.3-1.6L141.7,319.1z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.9487,
    y1: -276.4304,
    x2: 362.9679,
    y2: -290.6243,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M146.6,320.2l-0.2-1.3l-0.2-1.2l0.6,0.1l0.6,0.2l0.6,0.1l1.2,0.3l0.6,0.1l0.6,0.1l0.6,0.2l0,0.9l0.2,1 l0.2,1.1l0.3,1.2l0.4,1.3l0.5,1.2l0.5,1.3l0.5,1.3l0.6,1.3l0.7,1.2l0.7,1.1l0.7,1.1l0.7,1l0.8,0.9l0.8,0.7l0.8,0.6l-1.9,0.1 l-1.7-0.3l-1.5-0.6l-1.4-0.8l-1.1-1l-1-1.2l-0.9-1.4l-0.8-1.5l-0.7-1.6l-0.5-1.6l-0.4-1.6l-0.4-1.6l-0.4-1.6L146.6,320.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.6515,
    y1: -282.3952,
    x2: 374.4578,
    y2: -301.1236,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M151.2,320.2l-0.1-0.8l0-0.5l0.7,0.1l0.7,0.1l0.7,0.2l0.7,0.2l0.7,0.2l0.6,0.1l0.6,0.1l0.6,0.1l0.2,0.8 l0.6,2.1l0.4,1.3l0.4,1.3l0.4,1.4l0.5,1.4l0.6,1.4l0.6,1.4l0.6,1.3l0.7,1.2l0.7,1.1l0.8,0.9l0.8,0.7l0.9,0.5l1,0.3l-1.9,0.3 l-1.8-0.3l-1.6-0.6l-1.5-1l-1.4-1.2l-1.2-1.5l-1.1-1.7l-1-1.7l-0.8-1.8l-0.7-1.8l-0.6-1.7l-0.5-1.6l-0.3-1.4L151.2,320.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.6731,
    y1: -283.0984,
    x2: 385.4795,
    y2: -301.8268,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M157.2,322.3l-0.3-1.2l-0.3-0.9l0.5,0.1l0.5,0l0.5,0.1l0.5,0.1l0.5,0.1l0.4,0.1l0.4,0.1l0.4,0.1l0.2,1.1 l0.3,1.2l0.3,1.2l0.3,1.1l0.4,1.2l0.4,1.1l0.5,1.1l1.2,2.2l0.7,1l0.8,1l0.8,0.9l0.9,0.9l0.9,0.8l1,0.7l1.1,0.7l-1.8,0.4l-1.6,0 l-1.4-0.3l-1.3-0.7l-1.1-0.9l-1-1.1l-0.9-1.4l-0.8-1.5l-0.7-1.6l-0.6-1.6l-0.5-1.6l-0.5-1.6l-0.4-1.5L157.2,322.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.0441,
    y1: -280.6434,
    x2: 395.2092,
    y2: -307.9879,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M161.2,324.5l-0.5-1.8l-0.3-1.8l0.6,0.1l0.6,0.1l0.7,0.2l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.2l0.3,1 l0.2,1.1l0.3,1l0.3,1l0.3,1l0.3,1l0.4,1l0.4,1l0.5,1l0.6,1l0.7,1l0.9,1l1,0.9l1.2,1l1.4,1l1.5,0.9l-1.5,0l-1.4-0.1l-1.4-0.3 l-1.3-0.5l-1.2-0.7l-1.2-0.8l-1.1-1l-1.1-1.1l-0.9-1.2l-0.9-1.3l-0.8-1.5l-0.7-1.5l-0.6-1.6L161.2,324.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.6064,
    y1: -282.1547,
    x2: 409.7715,
    y2: -309.498,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M166.4,325.5l-0.4-1.8l-0.3-1.8l0.5,0.1l0.6,0.2l1.2,0.2l0.6,0.1l0.6,0.1l0.6,0.1l0.6,0.1l0.2,1.2l0.3,1.2 l0.4,1.2l0.5,1.2l0.6,1.2l0.7,1.2l0.7,1.1l0.8,1.1l0.9,1.1l1,1l1,0.9l1.1,0.9l1.2,0.8l1.3,0.7l1.3,0.6l1.4,0.5l-1.9,0.2l-1.9-0.1 l-1.7-0.3l-1.6-0.5l-1.5-0.6l-1.4-0.8l-1.3-1l-1.2-1.2l-1.1-1.2l-1-1.4l-0.9-1.5l-0.7-1.6l-0.6-1.7L166.4,325.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.5764,
    y1: -290.1666,
    x2: 420.773,
    y2: -302.5518,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M171.4,326.2l-0.5-1.6l-0.3-1.7l0.5,0.1l0.5,0l0.4,0.1l0.4,0.1l0.4,0l0.5,0.1l0.6,0.1l0.7,0.1l0.7,1.4 l0.6,1.3l1.1,2.5l0.6,1.1l0.6,1l0.6,1l0.6,0.9l0.7,0.9l0.8,0.8l0.9,0.9l1,0.8l1.1,0.8l1.3,0.8l1.4,0.8l1.6,0.8l-1.6-0.1l-1.6-0.3 l-1.6-0.4l-1.5-0.6l-1.4-0.7l-1.4-0.8l-1.3-0.9l-1.2-1.1l-1.1-1.2l-1.1-1.3l-0.9-1.4l-0.8-1.4l-0.7-1.5L171.4,326.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.877,
    y1: -284.5678,
    x2: 433.0422,
    y2: -311.9111,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M176.1,326.5l-0.7-1.6l-0.6-1.5l0.4,0l0.6,0.1l0.7,0.1l0.7,0.1l0.8,0.1l0.7,0.1l0.6,0.1l0.5,0l0.6,1.4 l0.6,1.4l0.7,1.3l0.7,1.2l0.8,1.1l0.9,1.1l0.9,1l1,1l1,0.9l1.1,0.9l1.2,0.9l1.2,0.8l1.3,0.7l1.4,0.7l1.4,0.6l1.5,0.6l-2.4,0.1 l-2.3-0.1l-2-0.3l-1.9-0.5l-1.7-0.7l-1.5-0.9l-1.4-1l-1.3-1.2l-1.2-1.3l-1.1-1.4l-0.9-1.4l-0.9-1.6l-0.8-1.5L176.1,326.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.3219,
    y1: -293.6221,
    x2: 444.5198,
    y2: -306.0087,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M181.5,327.7l-0.9-1.7l-0.7-1.8l0.7,0.1l0.7,0.1l0.8,0l0.8,0.1l0.7,0l0.6,0.1l0.5,0.1l0.2,0.1l0.9,0.7 l0.9,0.7l1.9,1.8l0.9,1l1,1l1,1.1l1,1.1l1,1.1l2.1,2.2l1.1,1.1l1.1,1.1l1.1,1l1.1,1l1.1,0.9l-1.3,0l-1.4-0.2l-1.5-0.3l-1.5-0.5 l-1.5-0.6l-1.6-0.8l-1.5-0.9l-1.5-1l-1.5-1.2l-1.4-1.2l-1.3-1.4l-1.3-1.5l-1.1-1.5L181.5,327.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.1775,
    y1: -287.0865,
    x2: 457.3427,
    y2: -314.431,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M188.3,327.6l-1.6-1.5l-1.6-1.3h0.6l0.6,0.1l0.7,0l0.7,0.2l0.8,0.1l0.8,0.1l0.7,0.1l0.6,0.1l2.5,2.3 l1.2,1.2l1.2,1.2l1.1,1.2l2.3,2.4l2.2,2.2l1.1,1l1,0.9l1,0.8l1,0.7l1,0.6l1,0.4l1,0.3l-1.3,0.8l-1.3,0.3l-1.3,0l-1.4-0.3 l-1.4-0.7l-1.4-0.9l-1.4-1.2l-1.4-1.3l-2.9-3.1l-3.1-3.4l-1.5-1.6L188.3,327.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.9613,
    y1: -297.3564,
    x2: 470.1578,
    y2: -309.7417,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E3895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    style: {
      stopColor: "#9B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#B9266F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    style: {
      stopColor: "#D02061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#E01B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    style: {
      stopColor: "#EA1850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M193.5,327.8l-1.3-1.2l-1.4-1.2l0.5,0.1l0.6,0l0.7,0.1l0.7,0.1l0.7,0.1l0.6,0l0.5,0.1h0.3l0.8,0.2l0.8,0.4 l0.8,0.5l0.9,0.7l0.9,0.9l0.9,1l1,1.1l1,1.2l1.1,1.2l1.1,1.2l1.3,1.3l1.3,1.2l1.4,1.2l1.5,1.1l1.6,1l1.8,0.9l-2,0l-1.9-0.2 l-1.7-0.5l-1.7-0.6l-1.5-0.8l-1.4-1l-1.4-1.1l-1.3-1.2l-1.3-1.3l-1.2-1.3l-1.2-1.3l-2.5-2.8L193.5,327.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.3552,
    y1: -228.6591,
    x2: 264.2523,
    y2: -205.8711,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M107.4,286.6l1.3-0.1l1.5,0.4l-0.5,0.5l-0.4,0.6l-0.4,0.7l-0.4,0.8l-0.4,0.9l-0.4,0.9l-0.3,1l-0.4,1l-0.3,1 l-0.3,1l-0.3,1l-0.3,1l-0.2,1l-0.2,0.9l-0.1,0.8l-0.1,0.8l-0.3,0l-0.2,0l-0.3-0.1l-0.2,0l-0.2-0.1l-0.2-0.1l-0.2,0l-0.3-0.1v-0.2 l-0.1-0.5l0-0.8l-0.1-1l-0.1-1.2l0.1-2.7l0.1-1.4l0.3-1.3l0.4-1.3l0.5-1.1l0.7-0.9l0.8-0.7L107.4,286.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.9862,
    y1: -231.8115,
    x2: 273.125,
    y2: -209.7552,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M114.3,286.5l0.5,0.3l0.4,0.3l-0.7,0.6l-0.7,0.7l-0.6,0.7l-0.6,0.8l-0.6,0.8l-0.5,0.8l-0.5,0.8l-0.4,0.9 l-0.4,0.9l-0.8,2l-0.3,1l-0.3,1.1l-0.3,1.1l-0.3,1.1l-0.3,1.2l-0.6-0.1l-0.4,0l-0.3-0.1l-0.2-0.1l-0.2,0l-0.2-0.1l-0.2-0.1 l-0.3-0.1l0.6-3.2l0.7-2.7l0.7-2.3l0.7-1.9l0.7-1.5l0.7-1.2l0.7-0.9l0.6-0.6l0.7-0.4l0.6-0.2l0.7-0.1l0.5,0.1l0.5,0.2 L114.3,286.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.1667,
    y1: -234.0488,
    x2: 282.0626,
    y2: -211.2608,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M118.5,286.5l1.1,0.6l1.1,1.1l-0.9,0.6l-0.8,0.7l-0.8,0.7l-0.7,0.7l-0.7,0.8l-0.6,0.9l-0.6,0.9l-0.5,0.9 l-0.5,1l-0.4,1l-0.4,1l-0.3,1.1l-0.3,1.1l-0.3,1.2l-0.3,1.2l-0.2,1.3l-0.5-0.1l-0.6-0.2l-0.6-0.2l-0.6-0.3l-0.6-0.3l-0.5-0.2 l-0.4-0.2l-0.3-0.1l0.1-1.2l0.3-1.3l0.4-1.5l0.5-1.6l0.6-1.6l0.7-1.6l0.8-1.5l0.9-1.4l0.9-1.3l1-1.1l1-0.8l1.1-0.6l1.1-0.2 L118.5,286.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.0104,
    y1: -239.2001,
    x2: 293.1492,
    y2: -217.1452,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M113,300l-0.4,1.8l-0.2,1.8l0.6,0.1l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.2l0.6,0.1l0.6,0.2l0.6,0.1l0.4-1.1 l0.4-1.2l0.5-1.2l0.5-1.2l0.5-1.3l0.5-1.3l0.5-1.2l0.5-1.2l0.6-1.1l0.6-1l0.7-1l0.7-0.8l0.8-0.7l0.8-0.6l0.8-0.4l0.9-0.3 l-1.2-0.8l-1.2-0.4l-1.2-0.2l-1.2,0.2l-1.2,0.4l-1.2,0.6l-1.1,0.9l-1.1,1l-1,1.2l-1,1.4l-0.8,1.5l-0.7,1.6l-0.6,1.7L113,300z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.537,
    y1: -241.1238,
    x2: 305.4328,
    y2: -218.3344,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M118.4,302.6l-0.6,1.5l-0.6,1.4l0.5,0l0.5,0.2l0.5,0.1l0.5,0.2l0.5,0.2l0.5,0.2l0.5,0.1l0.5,0.1l0-0.2 l0-0.5l0.1-0.6l0.1-0.9l0.3-1l0.4-1.2l0.4-1.3l0.5-1.3l0.6-1.3l0.7-1.3l0.9-1.3l1-1.2l1.2-1.2l1.4-1l1.6-0.9l1.8-0.6l-1.9-0.8 l-1.7-0.4l-1.5,0l-1.3,0.3L125,290l-1,0.8l-0.9,1l-0.8,1.2l-0.7,1.4l-0.6,1.5l-0.6,1.6l-0.6,1.6l-0.6,1.6L118.4,302.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.7226,
    y1: -247.5827,
    x2: 315.8614,
    y2: -225.5264,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M122.2,302.6l-0.4,2l-0.3,2.2l5.1,1.3l0.3-0.8l0.4-1l0.4-1l0.5-1.1l0.6-1.2l0.6-1.2l0.7-1.2l0.7-1.2 l0.8-1.2l0.9-1.2l1-1.1l1-1l1.1-0.9l1.2-0.8l1.3-0.7l1.4-0.5l-1.1-0.8l-1.3-0.5l-1.4-0.2l-1.4,0.1l-1.5,0.3l-1.5,0.6l-1.4,0.8 l-1.4,1l-1.4,1.2l-1.3,1.4l-1.1,1.6l-1,1.7l-0.9,1.8L122.2,302.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.9853,
    y1: -248.2184,
    x2: 328.8811,
    y2: -225.4304,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M136.4,303.7l0.6-1.3l0.6-1.3l0.6-1.3l0.7-1.2l0.7-1.1l0.8-1l0.8-0.9l0.8-0.8l0.9-0.7l1-0.5l1-0.4l-0.9-0.6 l-1-0.4l-1-0.3l-1.1-0.1l-1.2,0.1l-1.2,0.3l-1.2,0.5l-1.3,0.7l-1.3,0.9l-1.3,1.2l-1.3,1.5l-1.2,1.7l-1.2,2l-1.2,2.2l-1.1,2.6 l-1,2.8l0.7,0.1l0.9,0.2l0.9,0.3l1,0.3l1,0.3l0.9,0.3l0.8,0.3l0.7,0.2l0.5-1.2l1.1-2.6l0.5-1.3L136.4,303.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.859,
    y1: -252.7198,
    x2: 343.7561,
    y2: -229.9318,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M135.1,307.6l-0.6,1.5l-0.6,1.3l0.7,0.1l0.6,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.6,0.1l0.6,0.1l0.7,0.1l0.6-1.3 l0.6-1.3l0.6-1.3l1.2-2.5l0.6-1.1l0.6-1.1l0.6-1l0.7-1l0.8-0.9l0.8-0.9l0.9-0.8l1-0.8l1-0.7l1.2-0.6l1.2-0.6l-2-1.1l-1.8-0.6 l-1.7-0.1l-1.5,0.3l-1.3,0.6l-1.3,0.9l-1.1,1.1l-1,1.4l-0.9,1.5l-0.8,1.6l-0.7,1.7l-0.7,1.7l-0.7,1.7L135.1,307.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.1458,
    y1: -261.7606,
    x2: 354.2846,
    y2: -239.7043,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M140.1,309l-0.6,1.4l-0.5,1.2l0.7,0.1l0.6,0.1l0.6,0.1l0.5,0.1l0.6,0.2l0.6,0.1l0.7,0.1l0.8,0.1l0.9-2 l0.9-1.8l0.8-1.7l0.8-1.5l0.8-1.4l0.7-1.2l0.8-1.1l0.7-1l0.8-0.8l0.8-0.7l0.8-0.6l0.8-0.5l0.8-0.4l0.9-0.3l0.9-0.2l1-0.1l-1.8-1 l-1.7-0.5l-1.6-0.1l-1.6,0.2l-1.4,0.6l-1.4,0.9l-1.3,1.1l-1.2,1.3l-1.1,1.5l-1,1.5l-0.9,1.6l-0.8,1.6l-0.8,1.6L140.1,309z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.5797,
    y1: -259.597,
    x2: 366.4768,
    y2: -236.809,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M145.3,310.2l-0.6,1.3l-0.5,1.2l0.6,0.1l0.5,0.1l0.6,0.1l0.5,0.2l0.5,0.1l0.5,0.1l0.6,0.1l0.6,0.1l0.3-1 l0.4-1.1l0.5-1.1l0.6-1.2l0.7-1.2l1.7-2.4l0.9-1.2l1-1.1l1-1.1l1-1l1-0.8l1.1-0.8l1-0.6l1-0.5l1-0.3l-1.8-0.8l-1.7-0.4l-1.6,0 l-1.6,0.3l-1.4,0.6l-1.3,0.8l-1.2,1.1l-1.2,1.2l-1,1.4l-1,1.5l-0.9,1.5l-0.8,1.5l-0.8,1.6L145.3,310.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.0984,
    y1: -269.4911,
    x2: 375.2372,
    y2: -247.4348,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M149.1,312.5l-0.3,0.8l-0.1,0.5l0.7,0.2l0.6,0.1l1.3,0.3l0.6,0.2l0.6,0.1l0.6,0.1l0.6,0.1l0.4-0.8l0.5-1 l0.6-1.1l0.7-1.2l0.7-1.3l0.8-1.3l0.8-1.3l0.9-1.3l0.9-1.2l1-1.1l1-1l1-0.8l1.1-0.7l1.1-0.4l1.1-0.2l1.1,0l-1.8-1l-1.8-0.4 l-1.8,0.1l-1.7,0.5l-1.6,0.8l-1.6,1.1l-1.5,1.3l-1.4,1.5l-1.3,1.6l-1.1,1.6l-1,1.6l-0.8,1.5l-0.7,1.3L149.1,312.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.7961,
    y1: -266.0159,
    x2: 387.6919,
    y2: -243.2279,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M155.2,312.8l-0.5,1.2l-0.5,1l0.6,0.1l0.5,0.1l0.4,0.1l0.4,0.1l0.4,0.1l0.4,0.2l0.4,0.1l0.4,0.1l0.4-1.2 l0.5-1.2l0.5-1.2l0.6-1.2l0.7-1.2l0.7-1.1l0.8-1.1l0.8-1l0.9-1l1-0.9l1-0.8l1.1-0.7l1.2-0.6l1.2-0.5l1.3-0.4l1.4-0.3l-1.6-1.1 l-1.6-0.6l-1.5-0.1l-1.5,0.3l-1.4,0.6l-1.3,0.9l-1.2,1.1l-1.2,1.3l-1.1,1.4l-1,1.5l-0.9,1.6l-0.9,1.6l-0.7,1.5L155.2,312.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.3138,
    y1: -276.582,
    x2: 394.4525,
    y2: -254.5257,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M159.3,312.2l-0.9,1.8l-0.7,1.9l1.3,0.2l0.6,0.2l0.6,0.2l0.6,0.1l0.6,0.2l0.6,0.2l0.6,0.1l0.4-1.1l0.4-1.1 l0.5-1.1l0.4-1.1l0.5-1.1l0.5-1l0.6-1.1l0.7-1l0.8-0.9l0.9-0.9l1-0.8l1.1-0.8l1.3-0.7l1.4-0.6l1.6-0.6l1.8-0.4l-1.4-0.5l-1.4-0.3 l-1.5-0.1l-1.4,0.1L170,302l-1.3,0.4l-1.3,0.7l-1.3,0.8l-1.2,1l-1.2,1.2l-1.1,1.3l-1.1,1.4l-1,1.6L159.3,312.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.6133,
    y1: -272.9211,
    x2: 410.5104,
    y2: -250.1331,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M164.4,313.4l-0.8,1.8l-0.7,1.9l0.6,0.1l0.6,0.1l0.7,0.1l1.3,0.2l0.7,0.1l1.4,0.2l0.4-1.4l0.5-1.3l0.5-1.3 l0.7-1.2l0.7-1.1l0.8-1.1l0.9-1l1-0.9l1.1-0.9l1.2-0.7l1.2-0.7l1.3-0.6l1.4-0.4l1.4-0.4l1.5-0.2l1.5-0.1l-1.9-0.8l-1.9-0.5 l-1.7-0.3l-1.7,0l-1.6,0.3l-1.6,0.4l-1.5,0.6l-1.4,0.8l-1.3,1l-1.3,1.2l-1.1,1.3l-1.1,1.5l-1,1.6L164.4,313.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.2405,
    y1: -284.6737,
    x2: 416.3793,
    y2: -262.6175,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M169.3,314.6l-0.6,1.7l-0.5,1.8l0.6,0l0.5,0l0.5,0.1l0.5,0.1l0.5,0.1l0.5,0.1l0.6,0.1l0.6,0.1l0.8-1.4 l0.8-1.4l0.7-1.2l0.6-1.2l0.7-1.1l0.6-1l0.6-1l0.7-0.9l0.8-0.8l0.9-0.7l1-0.7l1.1-0.6l1.3-0.6l1.4-0.5l1.6-0.4l1.8-0.4l-1.7-0.3 l-1.6-0.1l-1.6,0.1l-1.6,0.2l-1.6,0.4l-1.5,0.5l-1.4,0.6l-1.4,0.8l-1.3,0.9l-1.2,1.1l-1.1,1.2l-1,1.3l-0.9,1.5L169.3,314.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.648,
    y1: -279.5907,
    x2: 432.5438,
    y2: -256.8027,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M174.1,315.8l-0.8,1.6l-0.8,1.6l0.4,0l0.5,0l0.6,0.2l0.6,0.1l0.6,0.1l0.6,0.1l0.5,0l0.4,0.1l0.7-1.5 l0.8-1.3l0.9-1.3l0.9-1.2l1-1.1l1-1l1.1-0.9l1.2-0.9l1.2-0.8l1.3-0.7l1.3-0.6l1.4-0.6l1.4-0.5l1.5-0.5l1.6-0.4l1.6-0.4l-2.5-0.6 l-2.3-0.3l-2.1-0.1l-2,0.2l-1.8,0.4l-1.7,0.6l-1.5,0.7l-1.4,1l-1.3,1.1l-1.2,1.2l-1.1,1.3l-1,1.4l-0.9,1.5L174.1,315.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.2638,
    y1: -282.5004,
    x2: 442.1609,
    y2: -259.7124,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M179.1,316.2l-1.1,1.7l-0.9,1.9l0.7,0.1l0.7,0.1l0.7,0.1l0.7,0.1l0.6,0.1l0.5,0.2l0.4,0l0.3,0l1-0.6l1-0.7 l1-0.8l1.1-0.9l1.1-0.9l1.1-1l1.2-1l1.2-1l1.2-1l1.2-1l1.3-1l1.3-0.9l1.3-0.9l1.3-0.8l1.4-0.8l1.3-0.7l-1.4-0.3l-1.4,0l-1.6,0 l-1.6,0.3l-1.6,0.4l-1.7,0.5l-1.7,0.6l-1.7,0.8l-1.7,0.9l-1.6,1.1l-1.5,1.2l-1.5,1.3l-1.3,1.5L179.1,316.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.1394,
    y1: -286.0955,
    x2: 454.0352,
    y2: -263.3062,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M185.1,318.1l-1.8,1.3l-1.8,1.2l0.5,0.1l0.6,0l0.8,0.1l0.8,0l0.8,0h1.6l0.6,0l1.3-1l2.6-2.1l1.2-1.1l1.2-1 l1.1-1l1.1-1l1.1-1l1.2-0.9l1.1-0.8l1.2-0.7l1.2-0.6l1.3-0.5l1.3-0.4l1.4-0.2l1.4-0.2l-1.2-1.2l-1.3-0.7l-1.4-0.3l-1.4,0.1 l-1.5,0.4l-1.6,0.7l-1.6,1l-1.7,1.1l-3.4,2.8l-1.7,1.6l-1.7,1.5l-1.8,1.5L185.1,318.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.2524,
    y1: -278.8114,
    x2: 471.4304,
    y2: -259.5031,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M189.9,319.3l-1.6,1.1l-1.5,1l0.5,0l0.6,0.1l0.7,0.1l0.7,0l0.7,0.1l0.6,0.1l0.5,0.1l0.3,0l0.9,0l0.9-0.3 l0.9-0.5l1-0.6l1-0.8l1.1-0.9l1.1-1l2.4-2.2l1.3-1.2l1.4-1.1l1.5-1.1l1.6-1l1.7-0.9l1.8-0.8l1.9-0.6l-2.1-0.5l-1.9-0.2l-1.8,0.1 l-1.7,0.4l-1.6,0.6l-1.6,0.7l-1.5,0.9l-1.5,1l-2.9,2.4l-1.4,1.3l-1.4,1.3l-1.4,1.2L189.9,319.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.6166,
    y1: -286.2534,
    x2: 479.7946,
    y2: -266.9451,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#693594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    style: {
      stopColor: "#892E83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#B4246C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#D31D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#E61952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    style: {
      stopColor: "#ED174E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9E57E"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M194.3,321.3l-1.1,0.5l-0.9,0.2l0.8,0.1l0.8,0.1l0.9,0.1l1,0.2l1,0.1l1,0.2l0.9,0l0.8,0l1.4-1l1.2-1l1.1-1 l1.1-0.9l1-0.9l0.9-0.9l1-0.9l0.9-0.8l0.9-0.8l1-0.7l1.1-0.7l1.2-0.6l1.3-0.6l1.4-0.5l1.6-0.5l1.7-0.4l-1.8-1l-1.9-0.4h-1.9 l-1.9,0.4l-1.9,0.7l-1.9,1l-1.9,1.2l-1.8,1.3l-1.7,1.5l-1.7,1.5l-1.6,1.4l-1.5,1.3l-1.3,1.1L194.3,321.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.7427,
    y1: -192.8365,
    x2: 237.6212,
    y2: -228.4197,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M97.1,281.8l0.1-0.6l0.1-0.5l-0.8,1l-0.6,1.1l-0.4,1.1l-0.3,1.1l-0.1,1.2v1.2l0.2,1.2l0.3,1.2l0.3,1.2 l0.4,1.1l0.9,2.3l0.5,1.1l0.5,1.1l0.4,1l0.4,1l-0.1-0.2l0-0.3l-0.1-0.3v-0.4l0-0.5v-1.1l0-0.6l-0.1-0.6v-0.6l-0.1-0.7l-0.1-0.6 l0-0.6l-0.1-0.6l-0.1-0.5l-0.2-0.5l-0.2-0.5l-0.2-0.5l-0.2-0.5l-0.1-0.5l-0.2-0.6l-0.1-0.6l-0.1-0.6l-0.1-0.6l0-0.6l0-0.6v-0.6 l0-0.6l0-0.6L97.1,281.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.6338,
    y1: -191.2394,
    x2: 232.5123,
    y2: -226.8227,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M95,303.4l0.9-0.5l0.9-0.5l-0.8,0.8l-0.8,0.8l-0.8,0.8l-0.8,0.7l-0.8,0.8l-0.8,0.7l-0.8,0.7l-0.9,0.6 l-0.8,0.6l-0.9,0.5l-0.8,0.4l-0.9,0.3l-0.9,0.3l-0.9,0.1l-0.9,0l-0.9,0l0.9-0.5l0.9-0.6l0.9-0.5l0.9-0.5l0.8-0.5l0.8-0.5l0.8-0.5 l0.8-0.5l0.8-0.5l0.8-0.5l0.8-0.5l0.8-0.5l0.8-0.5L95,303.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.1035,
    y1: -192.0107,
    x2: 234.982,
    y2: -227.5939,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M98.2,297.9l0.4,0.6l0.4,0.6l-0.2-0.6l-0.3-0.6l-0.3-0.7l-0.6-1.4l-0.3-0.6l-0.4-0.6l-0.4-0.6l-0.5-0.6 l-0.6-0.5l-0.6-0.5l-0.7-0.4l-0.8-0.3l-0.8-0.3l-1-0.2l-1-0.1l0.7,0.4l0.6,0.4l0.6,0.4l0.6,0.4l0.6,0.4l0.5,0.5l0.6,0.5l0.5,0.5 l1.5,1.6l0.4,0.6l0.5,0.5L98.2,297.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.8895,
    y1: -194.1316,
    x2: 241.768,
    y2: -229.7149,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M99.9,297.7l0.2,0.9l0.2,0.9l0.1-1.1l0.1-1l0.1-1.1l0.1-1.1l0-1l0-1l-0.1-1l-0.1-1l-0.1-1l-0.2-0.9 l-0.3-0.9l-0.3-0.8l-0.4-0.7l-0.5-0.7l-0.5-0.6l-0.6-0.5l0.2,1l0.1,1l0.2,1l0.2,0.9l0.1,0.9l0.1,0.9l0.1,0.9l0.1,0.9l0.1,0.9 l0.2,0.9l0.1,0.8l0.2,0.9l0.2,0.9L99.9,297.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.0108,
    y1: -191.3548,
    x2: 232.8893,
    y2: -226.9393,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M97.4,297l0.6,0.7l0.5,0.5l-0.1-1.5l-0.2-1.3l-0.2-1.1l-0.4-1l-0.4-0.8l-0.5-0.7l-0.5-0.7l-0.6-0.6 l-0.5-0.6l-0.6-0.6l-0.5-0.7l-0.4-0.8l-0.4-0.9l-0.3-1l-0.3-1.2l-0.1-1.3l-0.9,0.8l-0.5,0.9l-0.3,1l-0.1,1l0.2,1l0.4,1.1l0.6,1.1 l0.6,1.1l0.7,1l0.8,1l0.8,1l0.8,0.9l0.8,0.9L97.4,297z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.3141,
    y1: -193.9506,
    x2: 241.1926,
    y2: -229.5352,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M100.8,285.9l0.3-0.9l0.4-0.9l-1.4,1.4l-1.2,1.3l-0.8,1.2l-0.6,1.2l-0.4,1.1l-0.2,1l0,1l0.1,0.9l0.3,0.9 l0.2,0.8l0.4,0.8l0.4,0.7l0.3,0.7l0.3,0.6l0.2,0.6l0.1,0.5v-1l0.1-1l0-1l0.1-1l0-0.9l0.1-0.9l0.1-0.9l0.1-0.9l0.2-0.9l0.1-0.9 l0.3-0.9l0.2-0.9l0.3-0.9L100.8,285.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.5768,
    y1: -190.908,
    x2: 231.4552,
    y2: -226.4926,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M95.3,302.8l1.5-0.2l-0.6,0.3l-0.6,0.2l-0.7,0.3l-0.7,0.3l-0.7,0.3l-0.7,0.2l-0.8,0.2l-0.8,0.1l-0.8,0.1 h-0.8l-0.8-0.1l-0.8-0.2L87,304l-0.8-0.4l-0.8-0.5l-0.8-0.6l0.8,0.1l0.8,0.2l0.8,0.1l0.8,0.1l0.8,0l0.8,0h1.5l0.8-0.1h0.7L93,303 l1.5-0.1L95.3,302.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.1558,
    y1: -190.4633,
    x2: 230.0342,
    y2: -226.0478,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M81.4,310.2l-0.4,0.4l-0.4,0.4l0.3-1.2l0.5-1l0.6-0.9l0.8-0.8l0.9-0.7l1-0.6l1.1-0.5l1.1-0.5l1.2-0.4 l1.2-0.4l2.5-0.6l1.2-0.3l1.2-0.3l1.1-0.2l1.1-0.2l-0.5,0.2l-0.7,0.4l-0.9,0.6l-1.1,0.6l-1.1,0.7l-1.1,0.6l-1.1,0.6l-1,0.4 l-0.6,0.1l-0.5,0.1l-0.6,0.1l-0.6,0.1l-0.6,0.3l-0.6,0.2l-0.5,0.3l-0.6,0.3l-0.5,0.3l-0.5,0.3l-0.5,0.4l-0.5,0.3l-0.4,0.4 L81.4,310.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.7811,
    y1: -192.8476,
    x2: 237.6596,
    y2: -228.4308,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M96.7,303.7l0.8-0.4l0.6-0.4l-0.7,1.4l-0.7,1.2l-0.7,0.9l-0.7,0.8l-0.7,0.6l-0.7,0.6l-1.5,0.9l-0.7,0.4 l-0.7,0.5l-0.7,0.5l-0.7,0.6l-0.7,0.7l-0.7,0.9l-0.6,1l-0.6,1.3l-0.4-1.1l-0.2-1.1l0.2-1.1l0.4-1l0.6-0.9l0.8-0.9l0.9-0.9l1-0.8 l1.1-0.8l1.1-0.7l1.2-0.7l1.1-0.6l1-0.5L96.7,303.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.4689,
    y1: -194.938,
    x2: 244.3473,
    y2: -230.5213,
    gradientTransform: "matrix(0.4592 0 0 -0.4592 -13.6505 192.1984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    style: {
      stopColor: "#CCDEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#B5CBD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    style: {
      stopColor: "#90ABBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#5E8096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#476C85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#5C7E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#87A3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#A9C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    style: {
      stopColor: "#C1D4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    style: {
      stopColor: "#CFE1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4E5EE"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M93.5,314.9l-0.2,0.9l-0.2,0.9l-0.5-1.9l-0.3-1.6l-0.1-1.5l0.1-1.3l0.3-1.1l0.4-1l0.5-0.8l0.6-0.7l0.7-0.6 l0.7-0.5l0.7-0.4l0.7-0.4l0.6-0.4l0.6-0.3l0.4-0.4l0.4-0.4l-0.5,0.8l-0.5,0.8l-0.5,0.8l-0.5,0.8l-0.4,0.8l-0.4,0.8l-0.4,0.8 l-0.4,0.8l-0.4,0.8l-0.3,0.8l-0.4,0.8l-0.3,0.8l-0.3,0.9L93.5,314.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApache);
export default __webpack_public_path__ + "static/media/Apache.a8bb5dccc3adafb2e9028d6cf32af3d0.svg";
export { ForwardRef as ReactComponent };